<!--Double navigation-->
<header>
   <!-- Sidebar navigation -->
   <div *ngIf="showMenu">
      <mdb-side-nav #sidenav class="wide sn-bg-1 fixed" [fixed]="true">
         <mdb-navbar-brand>
            <!-- Logo -->
            <li>
               <div class="logo-wrapper waves-light">
                  <a href="#"><img src="../../assets/img/amsLogo.png" class="img-fluid flex-center" /></a>
               </div>
            </li>
            <li>
               <small title="Version" class="text-white mt-1 flex-center">V3.16.2</small>
            </li>
            <div
               class="mx-3 text-white d-flex justify-content-center badge"
               [ngClass]="{
                  'bg-dangerAnim animate-bg': licenseBad,
                  'bg-warning': licenseWarn,
                  'bg-success': licenseGood
               }"
            >
               <span>Subscription expires in {{ licenseDays }} days</span>
            </div>
            <!--/. Logo -->
         </mdb-navbar-brand>

         <links>
            <!-- Side navigation links -->
            <li>
               <ul class="collapsible collapsible-accordion">
                  <mdb-accordion [multiple]="true" aria-multiselectable="false">
                     <!-- Collapsible link -->
                     <mdb-accordion-item
                        li
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'USR-CR',
                           'USR-VW',
                           'USR-ED',
                           'USR-DL',
                           'USR-MR',
                           'CUS-CR',
                           'CUS-VW',
                           'CUS-ED',
                           'CUS-DL',
                           'CUS-MR',
                           'RLE-CR',
                           'RLE-VW',
                           'RLE-ED',
                           'RLE-DL',
                           'RLE-MR',
                           'ERR-VW',
                           'RPT-VW',
                           'RN-VW'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Admin</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'USR-CR', 'USR-VW', 'USR-ED', 'USR-DL', 'USR-MR']">
                                 <a routerLinkActive="active" [routerLink]="['/admin/user']" class="waves-effect" mdbWavesEffect><i class="fa fa-user mr-2"></i> Users</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'CUS-CR', 'CUS-VW', 'CUS-ED', 'CUS-DL', 'CUS-MR']">
                                 <a routerLinkActive="active" [routerLink]="['/admin/custodian']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-users-cog mr-2"></i> Custodian</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RLE-CR', 'RLE-VW', 'RLE-ED', 'RLE-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/admin/role']" class="waves-effect" mdbWavesEffect><i class="fa fa-users mr-2"></i> Roles</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'ERR-VW']">
                                 <a routerLinkActive="active" [routerLink]="['/admin/errorlog']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-exclamation-circle mr-2"></i> System Errors</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN']">
                                 <a routerLinkActive="active" [routerLink]="['/admin/auditlog']" class="waves-effect" mdbWavesEffect><i class="fa fa-pen mr-2"></i> Audit Log</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RPT-VW']">
                                 <a [routerLink]="['/admin/reportdashboard']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RN-VW']">
                                 <a routerLinkActive="active" [routerLink]="['/admin/releasenotes']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-clipboard mr-2"></i> Release Notes</a
                                 >
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        li
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'BA-VW',
                           'BA-CR',
                           'BA-ED',
                           'BA-DL',
                           'CC-VW',
                           'CC-CR',
                           'CC-ED',
                           'CC-DL',
                           'DIM-VW',
                           'DIM-CR',
                           'DIM-ED',
                           'DIM-DL',
                           'SUP-VW',
                           'SUP-CR',
                           'SUP-ED',
                           'SUP-DL',
                           'STE-VW',
                           'STE-CR',
                           'STE-ED',
                           'STE-DL',
                           'BLD-VW',
                           'BLD-CR',
                           'BLD-ED',
                           'BLD-DL',
                           'ROOM-VW',
                           'ROOM-CR',
                           'ROOM-ED',
                           'ROOM-DL'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Setup</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li
                                 class="SecondLevelMenu"
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'BA-VW',
                                    'BA-CR',
                                    'BA-ED',
                                    'BA-DL',
                                    'CC-VW',
                                    'CC-CR',
                                    'CC-ED',
                                    'CC-DL',
                                    'DIM-VW',
                                    'DIM-CR',
                                    'DIM-ED',
                                    'DIM-DL',
                                    'SUP-VW',
                                    'SUP-CR',
                                    'SUP-ED',
                                    'SUP-DL'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>General Setup</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'BA-VW', 'BA-CR', 'BA-ED', 'BA-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/setup/businessarea']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-clone mr-2"></i> Business Area</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'CC-VW', 'CC-CR', 'CC-ED', 'CC-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/setup/costcentre']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-coins mr-2"></i> Cost Centre</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'DIM-VW', 'DIM-CR', 'DIM-ED', 'DIM-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/setup/dimension']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-cubes mr-2"></i> Dimensions</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'SUP-VW', 'SUP-CR', 'SUP-ED', 'SUP-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/setup/supplier']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-hand-holding-usd mr-2"></i> Supplier</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li
                                 class="SecondLevelMenu"
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'STE-VW',
                                    'STE-CR',
                                    'STE-ED',
                                    'STE-DL',
                                    'BLD-VW',
                                    'BLD-CR',
                                    'BLD-ED',
                                    'BLD-DL',
                                    'ROOM-VW',
                                    'ROOM-CR',
                                    'ROOM-ED',
                                    'ROOM-DL'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Location Setup</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'STE-VW', 'STE-CR', 'STE-ED', 'STE-DL']">
                                             <a [routerLink]="['/setup/site']" class="waves-effect" mdbWavesEffect><i class="fa fa-flag mr-2"></i> Sites</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'BLD-VW', 'BLD-CR', 'BLD-ED', 'BLD-DL']">
                                             <a [routerLink]="['/setup/building']" class="waves-effect" mdbWavesEffect><i class="fa fa-building mr-2"></i> Buildings</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'ROOM-VW', 'ROOM-CR', 'ROOM-ED', 'ROOM-DL']">
                                             <a [routerLink]="['/setup/room']" class="waves-effect" mdbWavesEffect><i class="fa fa-home mr-2"></i> Rooms</a>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        li
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'CLASS-VW',
                           'CLASS-CR',
                           'CLASS-ED',
                           'CLASS-DL',
                           'ACC-VW',
                           'ACC-CR',
                           'ACC-ED',
                           'ACC-DL',
                           'AGR-VW',
                           'AGR-CR',
                           'AGR-ED',
                           'AGR-DL',
                           'ATP-VW',
                           'ATP-CR',
                           'ATP-ED',
                           'ATP-DL',
                           'CTP-VW',
                           'CTP-CR',
                           'CTP-ED',
                           'CTP-DL',
                           'DTP-VW',
                           'DTP-CR',
                           'DTP-ED',
                           'DTP-DL',
                           'ATB-VW',
                           'ATB-CR',
                           'ATB-ED',
                           'ATB-DL',
                           'GLA-VW',
                           'GLA-CR',
                           'GLA-ED',
                           'GLA-DL'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Classification Setup</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'CLASS-VW', 'CLASS-CR', 'CLASS-ED', 'CLASS-DL', 'ACC-VW', 'ACC-CR', 'ACC-ED', 'ACC-DL']">
                                 <a [routerLink]="['/setupclass/classification']" class="waves-effect" mdbWavesEffect
                                    ><i class="k-icon k-i-thumbnails-down mr-2"></i> Classification</a
                                 >
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'AGR-VW', 'AGR-CR', 'AGR-ED', 'AGR-DL']">
                                 <a [routerLink]="['/setupclass/assetgroup']" class="waves-effect" mdbWavesEffect><i class="fa fa-cogs mr-2"></i> Asset Group</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'ATP-VW', 'ATP-CR', 'ATP-ED', 'ATP-DL']">
                                 <a [routerLink]="['/setupclass/assettype']" class="waves-effect" mdbWavesEffect><i class="fa fa-tools mr-2"></i> Asset Type</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'CTP-VW', 'CTP-CR', 'CTP-ED', 'CTP-DL']">
                                 <a [routerLink]="['/setupclass/componenttype']" class="waves-effect" mdbWavesEffect><i class="k-icon k-i-wrench mr-2"></i> Component Type</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'DTP-VW', 'DTP-CR', 'DTP-ED', 'DTP-DL']">
                                 <a [routerLink]="['/setupclass/descriptortype']" class="waves-effect" mdbWavesEffect><i class="fa fa-atom mr-2"></i> Descriptor Type</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'ATB-VW', 'ATB-CR', 'ATB-ED', 'ATB-DL']">
                                 <a [routerLink]="['/setupclass/attribute']" class="waves-effect" mdbWavesEffect><i class="k-icon k-i-page-properties mr-2"></i> Attributes</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'GLA-VW', 'GLA-CR', 'GLA-ED', 'GLA-DL']">
                                 <a [routerLink]="['/setupclass/account']" class="waves-effect" mdbWavesEffect><i class="k-icon k-i-file-ascx mr-2"></i> GL Accounts</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'FAR-EX',
                           'INT-VW',
                           'INT-AP',
                           'INT-DISC',
                           'INT-CA',
                           'INT-SNC',
                           'INT-EXP',
                           'CJRL-VW',
                           'CJRL-DISC',
                           'CJRL-AP',
                           'CJRL-CA',
                           '3RD-EXP',
                           'DIM-C-VW',
                           'DIM-C-CR',
                           'DIM-C-ED',
                           'DIM-C-CNL',
                           'DIM-C-AP',
                           'CC-C-VW',
                           'CC-C-CR',
                           'CC-C-ED',
                           'CC-C-AP',
                           'CC-C-CNL',
                           'CLASS-C-V',
                           'CLASS-C-CR',
                           'CLASS-C-ED',
                           'CLASS-C-CNL',
                           'CLASS-C-AP',
                           'BAR-REP-VW',
                           'BAR-REP-CR',
                           'BAR-REP-ED',
                           'BAR-REP-CNL',
                           'BAR-REP-AP',
                           'HIS-VW',
                           'ASSET-VW',
                           'ASSET-CR',
                           'ASSET-ED',
                           'ASSET-AP',
                           'ASSET-CNL'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Asset Management</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'FAR-EX', 'INT-VW', 'INT-AP', 'INT-DISC', 'INT-CA', 'INT-SNC', 'INT-EXP']">
                                 <a [routerLink]="['/assetmanagement/asset/register']" class="waves-effect" mdbWavesEffect><i class="fa fa-chart-line mr-2"></i> Asset Register</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'INT-VW', 'INT-AP', 'INT-DISC', 'INT-CA', 'INT-SNC', 'INT-EXP', 'CJRL-VW', 'CJRL-DISC', 'CJRL-AP', 'CJRL-CA']">
                                 <a [routerLink]="['/assetmanagement/asset/correctionjournalintegration']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-check-circle mr-2"></i> Correction Journals</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', '3RD-EXP']">
                                 <a [routerLink]="['/assetmanagement/asset/exportthirdparty']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-cogs mr-2"></i> 3rd Party Exports</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'DIM-C-VW', 'DIM-C-CR', 'DIM-C-ED', 'DIM-C-CNL', 'DIM-C-AP']">
                                 <a [routerLink]="['/assetmanagement/asset/dimensionchange']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-layer-group mr-2"></i> Dimension Change</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'CC-C-VW', 'CC-C-CR', 'CC-C-ED', 'CC-C-AP', 'CC-C-CNL']">
                                 <a [routerLink]="['/assetmanagement/asset/costcentrechange']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-coins mr-2"></i> Cost Centre Change</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'CLASS-C-V', 'CLASS-C-CR', 'CLASS-C-ED', 'CLASS-C-CNL', 'CLASS-C-AP']">
                                 <a [routerLink]="['/assetmanagement/asset/classificationchange']" class="waves-effect" mdbWavesEffect
                                    ><i class="k-icon k-i-wrench mr-2"></i> Classification Change</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'BAR-REP-VW', 'BAR-REP-CR', 'BAR-REP-ED', 'BAR-REP-CNL', 'BAR-REP-AP']">
                                 <a [routerLink]="['/assetmanagement/asset/barcodereplacement']" class="waves-effect" mdbWavesEffect
                                    ><i class="fas fa-barcode mr-2"></i> Barcode Replacement</a
                                 >
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'HIS-VW']">
                                 <a [routerLink]="['assetmanagement/asset/transactionhistory']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-history mr-2"></i> Transaction History</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'ASSET-CNL']">
                                 <a [routerLink]="['assetmanagement/asset/removebulk']" class="waves-effect" mdbWavesEffect><i class="fa fa-trash mr-2"></i> Remove Bulk Assets</a>
                              </li>
                                <li *appHasRole="['SYSTEM-ADMIN', 'ASSET-CR', 'ASSET-ED']">
                                 <a [routerLink]="['assetmanagement/asset/splitasset']" class="waves-effect" mdbWavesEffect><i class="fa fa-exchange-alt mr-2"></i> Split Assets</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'ASSET-VW', 'ASSET-CR', 'ASSET-ED', 'ASSET-AP', 'ASSET-CNL']">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Groups</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/general', 'GENERAL']" class="waves-effect" mdbWavesEffect
                                                ><i class="k-icon k-i-toggle-full-screen-mode mr-2"></i> General</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/vehicle', 'VEHICLE']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-truck mr-2"></i> Vehicle</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/road', 'ROAD']" class="waves-effect" mdbWavesEffect><i class="fa fa-road mr-2"></i> Road</a>
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/land', 'LAND']" class="waves-effect" mdbWavesEffect><i class="fa fa-tree mr-2"></i> Land</a>
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/building', 'BUILDING']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-building mr-2"></i> Building</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/water', 'WATER']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-bath mr-2"></i> Water</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/stormwater', 'STORMWATER']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-water mr-2"></i> Storm Water</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/sanitation', 'SANITATION']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-toilet-paper mr-2"></i> Sanitation</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/electricity', 'ELECTRICITY']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-lightbulb mr-2"></i> Electricity</a
                                             >
                                          </li>
                                          <li>
                                             <a [routerLink]="['/assetmanagement/asset/railway', 'RAILWAY']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-train mr-2"></i> Railway</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'M-END-RUN',
                           'M-END-RB',
                           'M-END-RP',
                           'RECON-VW',
                           'DEP-RUN',
                           'DEP-AP',
                           'DEP-RB',
                           'PU-VW',
                           'PU-CR',
                           'PU-AP',
                           'PU-ED',
                           'PU-CNL',
                           'FOR-EXP',
                           'BUD-VW',
                           'BUD-ED',
                           'BUD-AP',
                           'ACQ-VW',
                           'ACQ-CR',
                           'ACQ-ED',
                           'ACQ-CNL',
                           'DISP-VW',
                           'DISP-CR',
                           'DISP-ED',
                           'DISP-CNL',
                           'RULC-VW',
                           'RULC-CR',
                           'RULC-ED',
                           'RULC-CNL',
                           'RESC-VW',
                           'RESC-CR',
                           'RESC-ED',
                           'RESC-CNL',
                           'UPG-VW',
                           'UPG-CR',
                           'UPG-ED',
                           'UPG-CNL',
                           'IMP-VW',
                           'IMP-CR',
                           'IMP-ED',
                           'IMP-CNL',
                           'REV-VW',
                           'REV-CR',
                           'REV-ED',
                           'REV-CNL',
                           'ADJ-VW',
                           'ADJ-CR',
                           'ADJ-ED',
                           'ADJ-CNL',
                           'J-ADJ-VW',
                           'J-ADJ-CR',
                           'J-ADJ-ED',
                           'J-ADJ-AP',
                           'J-ADJ-CNL',
                           'TRAN-RP', 'DFZ-CR', 'DFZ-AP', 'DFZ-ED', 'DFZ-CNL', 'DFZ-VW'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Transactions</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'M-END-RUN', 'M-END-RB', 'M-END-RP']">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Month/Year End</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'M-END-RUN', 'M-END-RB', 'M-END-RP']">
                                             <a [routerLink]="['/financialTransaction/monthend']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-running mr-2"></i> Month End</a
                                             >
                                             <a [routerLink]="['/financialTransaction/yearend']" class="waves-effect" mdbWavesEffect><i class="fa fa-running mr-2"></i> Year End</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'RECON-VW']">
                                             <a [routerLink]="['/financialTransaction/reconciliation']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-balance-scale mr-2"></i> Reconciliations</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'DEP-RUN', 'DEP-AP', 'DEP-RB', 'PU-VW', 'PU-CR', 'PU-AP', 'PU-ED', 'PU-CNL', 'FOR-EXP', 'DFZ-CR', 'DFZ-AP', 'DFZ-ED', 'DFZ-CNL', 'DFZ-VW']">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Depreciation</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'DEP-RUN', 'DEP-AP', 'DEP-RB']">
                                             <a [routerLink]="['/financialTransaction/depreciation']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-running mr-2"></i> Run Monthly</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'PU-VW']">
                                             <a [routerLink]="['/financialTransaction/depreciation/productionofunit']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-truck-moving mr-2"></i> Production Of Unit</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'FOR-EXP']">
                                             <a [routerLink]="['/financialTransaction/depreciationforecast']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-chart-line mr-2"></i> Forecast</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'DFZ-CR', 'DFZ-AP', 'DFZ-ED', 'DFZ-CNL', 'DFZ-VW']">
                                             <a [routerLink]="['/financialTransaction/depreciationfreeze']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-snowflake mr-2"></i> Freeze Depreciation</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'BUD-VW', 'BUD-ED', 'BUD-AP']">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Budgeting</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li>
                                             <a [routerLink]="['/financialTransaction/budget']" class="waves-effect" mdbWavesEffect><i class="fa fa-running mr-2"></i> Budgets</a>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'ACQ-VW', 'ACQ-CR', 'ACQ-ED', 'ACQ-CNL']">
                                 <a [routerLink]="['/financialTransaction/acquisition']" class="waves-effect" mdbWavesEffect><i class="fa fa-credit-card mr-2"></i> Acquisitions</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'DISP-VW', 'DISP-CR', 'DISP-ED', 'DISP-CNL']">
                                 <a [routerLink]="['/financialTransaction/disposal']" class="waves-effect" mdbWavesEffect><i class="fa fa-recycle mr-2"></i> Disposals</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RULC-VW', 'RULC-CR', 'RULC-ED', 'RULC-CNL']">
                                 <a [routerLink]="['/financialTransaction/rulchange']" class="waves-effect" mdbWavesEffect><i class="fa fa-hourglass mr-2"></i> Rul Changes</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RESC-VW', 'RESC-CR', 'RESC-ED', 'RESC-CNL']">
                                 <a [routerLink]="['/financialTransaction/residualchange']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-coins mr-2"></i> Residual Changes</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'UPG-VW', 'UPG-CR', 'UPG-ED', 'UPG-CNL']">
                                 <a [routerLink]="['/financialTransaction/upgrade']" class="waves-effect" mdbWavesEffect><i class="fa fa-redo mr-2"></i> Upgrades</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'IMP-VW', 'IMP-CR', 'IMP-ED', 'IMP-CNL']">
                                 <a [routerLink]="['/financialTransaction/impairment']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-hand-point-down mr-2"></i> Impairments</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'REV-VW', 'REV-CR', 'REV-ED', 'REV-CNL']">
                                 <a [routerLink]="['/financialTransaction/revaluation']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-money-bill-wave mr-2"></i> Revaluations</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'ADJ-VW', 'ADJ-CR', 'ADJ-ED', 'ADJ-CNL']">
                                 <a [routerLink]="['/financialTransaction/adjustment']" class="waves-effect" mdbWavesEffect><i class="fa fa-adjust mr-2"></i> Adjustments</a>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'TRA-VW', 'TRA-CR', 'TRA-ED', 'TRA-CNL']">
                                 <a [routerLink]="['/financialTransaction/transfer']" class="waves-effect" mdbWavesEffect><i class="fa fa-random mr-2"></i> Transfers</a>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'TRAN-RP']">
                                 <a [routerLink]="['/financialTransaction/reportdashboard']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item li *appHasRole="['SYSTEM-ADMIN', 'WTP-VW', 'WTP-CR', 'WTP-ED', 'WTP-DL', 'WTV-VW', 'WTV-CR', 'WTV-ED', 'WTV-DL', 'WTR-VW']">
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i>Wear and Tear</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WTP-VW', 'WTP-CR', 'WTP-ED', 'WTP-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/setupclass/wat-type']" class="waves-effect" mdbWavesEffect><i class="fa fa-clone mr-2"></i> Type</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WTV-VW', 'WTV-CR', 'WTV-ED', 'WTV-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/setupclass/wat-version']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-coins mr-2"></i> Version</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WTR-VW']">
                                 <a routerLinkActive="active" [routerLink]="['/setupclass/wat-register']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-chart-line mr-2"></i> WAT Register</a
                                 >
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'WIP-EN-VW',
                           'WIP-EN-CR',
                           'WIP-EN-ED',
                           'WIP-EN-DL',
                           'WIP-CO-VW',
                           'WIP-CO-CR',
                           'WIP-CO-ED',
                           'WIP-CO-DL',
                           'WIP-FU-VW',
                           'WIP-FU-CR',
                           'WIP-FU-ED',
                           'WIP-FU-DL',
                           'WIP-QST-VW',
                           'WIP-QST-CR',
                           'WIP-QST-ED',
                           'WIP-QST-DL',
                           'WIP-TMP-VW',
                           'WIP-TMP-CR',
                           'WIP-TMP-ED',
                           'WIP-TMP-DL',
                           'WIP-PR-VW',
                           'WIP-PR-CR',
                           'WIP-PR-ED',
                           'WIP-PR-COMP',
                           'WIP-PR-DL',
                           'WIP-PR-DEACT',
                           'WIP-PR-TRAN',
                           'WIP-CE-VW',
                           'WIP-CE-CR',
                           'WIP-CE-ED',
                           'WIP-CE-DL',
                           'WIP-TR-VW',
                           'WIP-TR-CR',
                           'WIP-TR-ED',
                           'WIP-TR-DL',
                           'WIP-TR-ADDP',
                           'WIP-TR-IMP',
                           'WIP-AL-VW',
                           'WIP-AL-CR',
                           'WIP-AL-ED',
                           'WIP-AL-DL',
                           'WIP-MA-VW',
                           'WIP-MA-CR',
                           'WIP-MA-ED',
                           'WIP-MA-DL',
                           'WIP-PR',
                           'WIP-MA-EX',
                           'WIP-CO-CR',
                           'WIP-CO-ED',
                           'WIP-CO-DL',
                           'WIP-CO-VW',
                           'WIP-CO-EX'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Work in Progress</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li class="SecondLevelMenu">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Setup</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'WIP-EN-VW', 'WIP-EN-CR', 'WIP-EN-ED', 'WIP-EN-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/wip/engineer']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-pencil-ruler mr-2"></i> Engineers</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'WIP-CO-VW', 'WIP-CO-CR', 'WIP-CO-ED', 'WIP-CO-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/wip/contractor']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-hard-hat mr-2"></i> Contractors</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'WIP-FU-VW', 'WIP-FU-CR', 'WIP-FU-ED', 'WIP-FU-DL']">
                                             <a routerLinkActive="active" [routerLink]="['/wip/fund']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-university mr-2"></i> Fund</a
                                             >
                                          </li>

                                          <li>
                                             <mdb-accordion-item>
                                                <mdb-accordion-item-head mdbWavesEffect
                                                   ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Checklist Setup</mdb-accordion-item-head
                                                >
                                                <mdb-accordion-item-body>
                                                   <ul>
                                                      <li *appHasRole="['SYSTEM-ADMIN', 'WIP-QST-VW', 'WIP-QST-CR', 'WIP-QST-ED', 'WIP-QST-DL']">
                                                         <a routerLinkActive="active" [routerLink]="['/wip/question']" class="waves-effect" mdbWavesEffect
                                                            ><i class="fa fa-question-circle mr-2"></i> Questions</a
                                                         >
                                                      </li>
                                                      <li *appHasRole="['SYSTEM-ADMIN', 'WIP-TMP-VW', 'WIP-TMP-CR', 'WIP-TMP-ED', 'WIP-TMP-DL']">
                                                         <a routerLinkActive="active" [routerLink]="['/wip/checklisttemplate']" class="waves-effect" mdbWavesEffect
                                                            ><i class="fa fa-clipboard-list mr-2"></i> Checklist Template</a
                                                         >
                                                      </li>
                                                   </ul>
                                                </mdb-accordion-item-body>
                                             </mdb-accordion-item>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'WIP-PR-VW', 'WIP-PR-CR', 'WIP-PR-ED', 'WIP-PR-COMP', 'WIP-PR-DL', 'WIP-PR-DEACT', 'WIP-PR-TRAN']">
                                 <a routerLinkActive="active" [routerLink]="['/wip/project']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-project-diagram mr-2"></i> Project</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WIP-CE-VW', 'WIP-CE-CR', 'WIP-CE-ED', 'WIP-CE-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/wip/certificate']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-certificate mr-2"></i> Certificate</a
                                 >
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'WIP-TR-VW', 'WIP-TR-CR', 'WIP-TR-ED', 'WIP-TR-DL', 'WIP-TR-ADDP', 'WIP-TR-IMP']">
                                 <a routerLinkActive="active" [routerLink]="['/wip/transaction']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-money-bill mr-2"></i> Transaction</a
                                 >
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'WIP-AL-VW', 'WIP-AL-CR', 'WIP-AL-ED', 'WIP-AL-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/wip/allocationAdjustment']" class="waves-effect" mdbWavesEffect
                                    ><i class="fas fa-money-bill-alt mr-2"></i> Allocation Adjustment</a
                                 >
                              </li>
                              
                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'WIP-MA-VW',
                                    'WIP-MA-CR',
                                    'WIP-MA-ED',
                                    'WIP-MA-DL',
                                    'WIP-MA-EX',
                                    'WIP-CO-CR',
                                    'WIP-CO-ED',
                                    'WIP-CO-DL',
                                    'WIP-CO-VW',
                                    'WIP-CO-EX'
                                 ]"
                              >
                                 <a routerLinkActive="active" [routerLink]="['/wip/masterAsset']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-truck-monster mr-2"></i> Master Asset</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WIP-RP']">
                                 <a [routerLink]="['/wip/reportdashboard1']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <!--Lease Management -->
                     <!------------------>
                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'LSE-ALL',
                           'LSE-CR',
                           'LSE-ED',
                           'LSE-DL',
                           'LSE-VW',
                           'LSE-PAY-CR',
                           'LSE-PAY-ED',
                           'LSE-PAY-DL',
                           'LSE-PAY-AP',
                           'LSE-PAY-CNL',
                           'LSE-PAY-VW',
                           'LSE-INT-CR',
                           'LSE-INT-ED',
                           'LSE-INT-DL',
                           'LSE-INT-AP',
                           'LSE-INT-CNL',
                           'LSE-INT-VW',
                           'LSE-TAK-CR',
                           'LSE-TAK-ED',
                           'LSE-TAK-VW',
                           'LSE-RUN',
                           'LSE-ITEM-CR',
                           'LSE-ITEM-ED',
                           'LSE-ITEM-DL',
                           'LSE-ITEM-VW',
                           'LSE-AP',
                           'LSE-INTADJ-CR',
                           'LSE-INTADJ-ED',
                           'LSE-INTADJ-DL',
                           'LSE-INTADJ-AP',
                           'LSE-INTADJ-CNL',
                           'LSE-INTADJ-VW',
                           'LSE-CONFEE-CR',
                           'LSE-CONFEE-ED',
                           'LSE-CONFEE-DL',
                           'LSE-CONFEE-AP',
                           'LSE-CONFEE-CNL',
                           'LSE-CONFEE-VW',
                           'LSE-DISC-CR',
                           'LSE-DISC-ED',
                           'LSE-DISC-DL',
                           'LSE-DISC-AP',
                           'LSE-DISC-CNL',
                           'LSE-DISC-VW',
                           'LSE-MCONFEE-CR',
                           'LSE-MCONFEE-ED',
                           'LSE-MCONFEE-DL',
                           'LSE-MCONFEE-AP',
                           'LSE-MCONFEE-CNL',
                           'LSE-MCONFEE-VW',
                           'LSE-REPORT',
                           'LSE-TERME-CR', 
                           'LSE-TERME-ED', 
                           'LSE-TERME-DL', 
                           'LSE-TERME-AP',
                           'LSE-TERME-CNL',
                           'LSE-TERME-VW',
                           'LSE-TERMNATION-CR', 
                           'LSE-TERMNATION-ED', 
                           'LSE-TERMNATION-DL', 
                           'LSE-TERMNATION-AP', 
                           'LSE-TERMNATION-CNL', 
                           'LSE-TERMNATION-VW',
                           'LSE-SETTLE-CR', 
                           'LSE-SETTLE-ED', 
                           'LSE-SETTLE-DL', 
                           'LSE-SETTLE-AP', 
                           'LSE-SETTLE-CNL', 
                           'LSE-SETTLE-VW', 
                           'LSE-CLOSE-CR', 
                           'LSE-CLOSE-ED', 
                           'LSE-CLOSE-AP', 
                           'LSE-CLOSE-VW',
                           'S-LSE-ALL',
                           'S-LSE-CR',
                           'S-LSE-ED',
                           'S-LSE-DL',
                           'S-LSE-AP',
                           'S-LSE-VW',
                           'S-LSE-PAY-CR',
                           'S-LSE-PAY-ED',
                           'S-LSE-PAY-DL',
                           'S-LSE-PAY-AP',
                           'S-LSE-PAY-CNL',
                           'S-LSE-PAY-VW',
                           'S-LSE-INT-CR',
                           'S-LSE-INT-ED',
                           'S-LSE-INT-DL',
                           'S-LSE-INT-AP',
                           'S-LSE-INT-CNL',
                           'S-LSE-INT-VW',
                           'S-LSE-TAK-CR',
                           'S-LSE-TAK-ED',
                           'S-LSE-TAK-ARI',
                           'S-LSE-TAK-VW',
                           'S-LSE-RUN',
                           'S-LSE-ITEM-CR',
                           'S-LSE-ITEM-ED',
                           'S-LSE-ITEM-DL',
                           'S-LSE-ITEM-VW',
                           'S-LSE-INTADJ-CR',
                           'S-LSE-INTADJ-ED',
                           'S-LSE-INTADJ-DL',
                           'S-LSE-INTADJ-AP',
                           'S-LSE-INTADJ-CNL',
                           'S-LSE-INTADJ-VW',
                           'S-LSE-CONFEE-CR',
                           'S-LSE-CONFEE-ED',
                           'S-LSE-CONFEE-DL',
                           'S-LSE-CONFEE-VW',
                           'S-LSE-DISC-CR',
                           'S-LSE-DISC-ED',
                           'S-LSE-DISC-DL',
                           'S-LSE-DISC-VW',
                           'S-LSE-MCONFEE-CR',
                           'S-LSE-MCONFEE-ED',
                           'S-LSE-MCONFEE-DL',
                           'S-LSE-MCONFEE-VW',
                           'S-LSE-PENFEE-CR', 
                           'S-LSE-PENFEE-ED', 
                           'S-LSE-PENFEE-DL', 
                           'S-LSE-PENFEE-AP', 
                           'S-LSE-PENFEE-CNL', 
                           'S-LSE-PENFEE-VW',
                           'S-LSE-TERME-CR', 
                           'S-LSE-TERME-ED', 
                           'S-LSE-TERME-DL', 
                           'S-LSE-TERME-AP',
                           'S-LSE-TERME-CNL',
                           'S-LSE-TERME-VW',
                           'S-LSE-TERMNATION-CR', 
                           'S-LSE-TERMNATION-ED', 
                           'S-LSE-TERMNATION-DL', 
                           'S-LSE-TERMNATION-AP', 
                           'S-LSE-TERMNATION-CNL', 
                           'S-LSE-TERMNATION-VW',
                           'S-LSE-SETTLE-CR', 
                           'S-LSE-SETTLE-ED', 
                           'S-LSE-SETTLE-DL', 
                           'S-LSE-SETTLE-AP', 
                           'S-LSE-SETTLE-CNL', 
                           'S-LSE-SETTLE-VW', 
                           'S-LSE-CLOSE-CR', 
                           'S-LSE-CLOSE-ED', 
                           'S-LSE-CLOSE-AP', 
                           'S-LSE-CLOSE-VW',
                           'S-LSE-INV-REP', 
                           'S-LSE-INV-AP', 
                           'S-LSE-INV-DISC',
                           'S-LSE-INV-VW',
                           'S-LSE-INVCREDIT-REP', 
                           'S-LSE-INVCREDIT-AP', 
                           'S-LSE-INVCREDIT-DISC',
                           'S-LSE-INVCREDIT-VW',
                           'S-LSE-INTI-REP',
                           'S-LSE-INTI-VW',
                           'S-LSE-INVP-VW',
                           'S-LSE-REPORT',
                           'S-LSE-PAYMENTADJ',
                           'S-LSE-PAYMENTADJ-AP',
                           'S-LSE-PAYMENTADJ-VW'

                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Lease Management</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <mdb-accordion-item>
                              <ul>
                                 <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Lease Management</mdb-accordion-item-head>
                                 <mdb-accordion-item-body>
                                    <mdb-accordion-item>
                                       <ul>
                                          <li
                                             *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'LSE-ALL',
                                                'LSE-CR',
                                                'LSE-ED',
                                                'LSE-VW',
                                                'LSE-ITEM-CR',
                                                'LSE-ITEM-ED',
                                                'LSE-ITEM-VW',
                                                'LSE-AP',
                                                'LSE-ITEM-DL',
                                                'LSE-DL',
                                                'LSE-CONFEE-CR',
                                                'LSE-CONFEE-ED',
                                                'LSE-MCONFEE-CR',
                                                'LSE-MCONFEE-ED',
                                                'LSE-DISC-CR',
                                                'LSE-DISC-ED',
                                                'LSE-TERME-CR', 
                                                'LSE-TERME-ED', 
                                                'LSE-TERME-DL', 
                                                'LSE-TERME-AP',
                                                'LSE-TERME-CNL',
                                                'LSE-TERME-VW',
                                                'LSE-TERMNATION-CR', 
                                                'LSE-TERMNATION-ED', 
                                                'LSE-TERMNATION-DL', 
                                                'LSE-TERMNATION-AP', 
                                                'LSE-TERMNATION-CNL', 
                                                'LSE-TERMNATION-VW',
                                                'LSE-SETTLE-CR', 
                                                'LSE-SETTLE-ED', 
                                                'LSE-SETTLE-DL', 
                                                'LSE-SETTLE-AP', 
                                                'LSE-SETTLE-CNL', 
                                                'LSE-SETTLE-VW', 
                                                'LSE-CLOSE-CR', 
                                                'LSE-CLOSE-ED', 
                                                'LSE-CLOSE-AP', 
                                                'LSE-CLOSE-VW',
                                             ]"
                                             title="Lease"
                                          >
                                             <a [routerLink]="['/leaseManagement/leaseAgreement']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fas fa-balance-scale mr-2"></i>Lease Agreements</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                           'SYSTEM-ADMIN',
                                           'LSE-ALL',
                                           'LSE-PAY-CR', 
                                           'LSE-PAY-ED', 
                                           'LSE-PAY-DL', 
                                           'LSE-PAY-AP', 
                                           'LSE-PAY-CNL', 
                                           'LSE-PAY-VW'
                                           ]"
                                            title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/additionalPayment']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fas fa-credit-card mr-2"></i>Additional Payments</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                           'SYSTEM-ADMIN',
                                           'LSE-ALL', 
                                           'LSE-INT-CR', 
                                           'LSE-INT-ED', 
                                           'LSE-INT-DL', 
                                           'LSE-INT-AP', 
                                           'LSE-INT-CNL', 
                                           'LSE-INT-VW']"
                                           title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/interestRateChanges']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fas fa-chart-line mr-2"></i>Interest Rate Change</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                           'SYSTEM-ADMIN',
                                           'LSE-ALL', 
                                           'LSE-INTADJ-CR', 
                                           'LSE-INTADJ-ED', 
                                           'LSE-INTADJ-DL', 
                                           'LSE-INTADJ-AP', 
                                           'LSE-INTADJ-CNL', 
                                           'LSE-INTADJ-VW']"
                                            title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/interestBalanceChanges']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fas fa-chart-line mr-2"></i>Interest Adjustment</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                          'SYSTEM-ADMIN', 
                                          'LSE-ALL', 
                                          'LSE-CONFEE-CR', 
                                          'LSE-CONFEE-ED', 
                                          'LSE-CONFEE-DL', 
                                          'LSE-CONFEE-AP', 
                                          'LSE-CONFEE-CNL', 
                                          'LSE-CONFEE-VW']"
                                           title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/contractFees']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-money-bill-wave mr-2"></i>Once-Off Contract Fees</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'LSE-ALL', 
                                             'LSE-MCONFEE-CR', 
                                             'LSE-MCONFEE-ED', 
                                             'LSE-MCONFEE-DL', 
                                             'LSE-MCONFEE-AP',
                                             'LSE-MCONFEE-CNL',
                                             'LSE-MCONFEE-VW']"
                                              title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/monthlyContractFees']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-coins mr-2"></i>Monthly Contract Fees</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'LSE-ALL', 
                                             'LSE-DISC-CR', 
                                             'LSE-DISC-ED', 
                                             'LSE-DISC-DL', 
                                             'LSE-DISC-AP', 
                                             'LSE-DISC-CNL', 
                                             'LSE-DISC-VW']" 
                                             title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/discounts']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-adjust mr-2"></i>Discounts</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'LSE-ALL', 
                                             'LSE-TAK-CR', 
                                             'LSE-TAK-ED', 
                                             'LSE-TAK-VW']" 
                                             title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/takeon']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-sliders-h mr-2"></i>Take On</a
                                             >
                                          </li>
                                          <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'LSE-ALL', 
                                                'LSE-TERME-CR', 
                                                'LSE-TERME-ED', 
                                                'LSE-TERME-DL', 
                                                'LSE-TERME-AP',
                                                'LSE-TERME-CNL',
                                                'LSE-TERME-VW',
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreement/termExtensions']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-hourglass mr-2"></i>Lease Term Extensions</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'LSE-ALL', 
                                             'LSE-TERMNATION-CR', 
                                             'LSE-TERMNATION-ED', 
                                             'LSE-TERMNATION-DL', 
                                             'LSE-TERMNATION-AP', 
                                             'LSE-TERMNATION-CNL', 
                                             'LSE-TERMNATION-VW']" 
                                             title="Lease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/terminations']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-hourglass mr-2"></i>Lease Termination</a
                                             >
                                          </li>

                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'LSE-ALL', 
                                                'LSE-SETTLE-CR', 
                                                'LSE-SETTLE-ED', 
                                                'LSE-SETTLE-DL', 
                                                'LSE-SETTLE-AP', 
                                                'LSE-SETTLE-CNL', 
                                                'LSE-SETTLE-VW', 
                                                ]" 
                                                title="Lease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreement/settlements']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-hourglass mr-2"></i>Lease Settlements</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'LSE-ALL', 
                                                'LSE-CLOSE-CR', 
                                                'LSE-CLOSE-ED', 
                                                'LSE-CLOSE-AP', 
                                                'LSE-CLOSE-VW',
                                                ]" 
                                                title="Lease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreement/closures']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-coins mr-2"></i>Lease Closures</a
                                                >
                                             </li>
                                          <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'LSE-RUN', 
                                             'LSE-ALL']"
                                              title="Lease Agreement Journals">
                                             <a routerLinkActive="active" [routerLink]="['/leaseManagement/leaseAgreementJournal']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-running mr-2"></i> Lease Agreement Journals</a
                                             >
                                          </li>
                                              <li
                                                *appHasRole="[
                                                   'SYSTEM-ADMIN',
                                                   'LSE-ALL',
                                                   'LSE-REPORT',
                                                ]"
                                                title="Reports"
                                             >
                                                <a [routerLink]="['/leaseManagement/leaseAgreementReports']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-print mr-2"></i>Reports</a
                                                >
                                             </li>
                                       </ul>
                                    </mdb-accordion-item>
                                 </mdb-accordion-item-body>
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Sales Lease Management</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <mdb-accordion-item>
                                          <ul>
                                             <li
                                                *appHasRole="[
                                                   'SYSTEM-ADMIN',
                                                   'S-LSE-ALL',
                                                   'S-LSE-CR',
                                                   'S-LSE-ED',
                                                   'S-LSE-AP',
                                                   'S-LSE-VW',
                                                   'S-LSE-DL',
                                                   'S-LSE-ITEM-CR',
                                                   'S-LSE-ITEM-ED',
                                                   'S-LSE-ITEM-VW',
                                                   'S-LSE-ITEM-DL',
                                                   'S-LSE-CONFEE-CR',
                                                   'S-LSE-CONFEE-ED',
                                                   'S-LSE-CONFEE-DL',
                                                   'S-LSE-CONFEE-VW',
                                                   'S-LSE-DISC-CR',
                                                   'S-LSE-DISC-ED',
                                                   'S-LSE-DISC-DL',
                                                   'S-LSE-DISC-VW',
                                                   'S-LSE-MCONFEE-CR',
                                                   'S-LSE-MCONFEE-ED',
                                                   'S-LSE-MCONFEE-DL',
                                                   'S-LSE-MCONFEE-VW',
                                                ]"
                                                title="SalesLease"
                                             >
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fas fa-balance-scale mr-2"></i>Sales Lease Agreements</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL',
                                                'S-LSE-PAY-CR',
                                                'S-LSE-PAY-ED',
                                                'S-LSE-PAY-DL',
                                                'S-LSE-PAY-AP',
                                                'S-LSE-PAY-CNL',
                                                'S-LSE-PAY-VW'
                                                ]"
                                                 title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/additionalPayment']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fas fa-credit-card mr-2"></i>Additional Payments</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL',
                                                'S-LSE-INT-CR',
                                                'S-LSE-INT-ED',
                                                'S-LSE-INT-DL',
                                                'S-LSE-INT-AP',
                                                'S-LSE-INT-CNL',
                                                'S-LSE-INT-VW'
                                                ]"
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/interestRateChanges']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fas fa-chart-line mr-2"></i>Interest Rate Change</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-INTADJ-CR', 
                                                'S-LSE-INTADJ-ED', 
                                                'S-LSE-INTADJ-DL', 
                                                'S-LSE-INTADJ-AP',
                                                'S-LSE-INTADJ-CNL',
                                                'S-LSE-INTADJ-VW'
                                                ]"
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/interestBalanceChanges']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fas fa-chart-line mr-2"></i>Interest Adjustment</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL', 
                                                'S-LSE-CONFEE-CR',
                                                'S-LSE-CONFEE-ED',
                                                'S-LSE-CONFEE-DL',
                                                'S-LSE-CONFEE-VW'
                                                ]"
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/contractFees']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-money-bill-wave mr-2"></i>Once-Off Contract Fees</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL',
                                                'S-LSE-MCONFEE-CR',
                                                'S-LSE-MCONFEE-ED', 
                                                'S-LSE-MCONFEE-DL', 
                                                'S-LSE-MCONFEE-VW'
                                                ]"
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/monthlyContractFees']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-coins mr-2"></i>Monthly Contract Fees</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-DISC-CR', 
                                                'S-LSE-DISC-ED', 
                                                'S-LSE-DISC-DL', 
                                                'S-LSE-DISC-VW'
                                                ]"
                                                 title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/discounts']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-adjust mr-2"></i>Discounts</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-TAK-CR', 
                                                'S-LSE-TAK-ED', 
                                                'S-LSE-TAK-ARI',
                                                'S-LSE-TAK-VW'
                                                ]"
                                                title="Lease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/takeOn']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-sliders-h mr-2"></i>Take On</a
                                                >
                                             </li>

                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL', 
                                                'S-LSE-PENFEE-CR', 
                                                'S-LSE-PENFEE-ED', 
                                                'S-LSE-PENFEE-DL', 
                                                'S-LSE-PENFEE-AP', 
                                                'S-LSE-PENFEE-CNL', 
                                                'S-LSE-PENFEE-VW',
                                                ]"
                                                 title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/penaltyFees']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-coins mr-2"></i>Penalty Fees</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL', 
                                                'S-LSE-PAYMENTADJ', 
                                                'S-LSE-PAYMENTADJ-AP', 
                                                'S-LSE-PAYMENTADJ-VW',
                                                ]"
                                                 title="Schedule Adjustment">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/adjustPaymentSchedule']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-adjust mr-2"></i>Schedule Adjustment</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-TERME-CR', 
                                                'S-LSE-TERME-ED', 
                                                'S-LSE-TERME-DL', 
                                                'S-LSE-TERME-AP',
                                                'S-LSE-TERME-CNL',
                                                'S-LSE-TERME-VW',
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/termExtensions']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-hourglass mr-2"></i>Lease Term Extensions</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-TERMNATION-CR', 
                                                'S-LSE-TERMNATION-ED', 
                                                'S-LSE-TERMNATION-DL', 
                                                'S-LSE-TERMNATION-AP', 
                                                'S-LSE-TERMNATION-CNL', 
                                                'S-LSE-TERMNATION-VW'
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/terminations']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-hourglass mr-2"></i>Lease Termination</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-SETTLE-CR', 
                                                'S-LSE-SETTLE-ED', 
                                                'S-LSE-SETTLE-DL', 
                                                'S-LSE-SETTLE-AP', 
                                                'S-LSE-SETTLE-CNL', 
                                                'S-LSE-SETTLE-VW', 
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/settlements']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-hourglass mr-2"></i>Lease Settlements</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-CLOSE-CR', 
                                                'S-LSE-CLOSE-ED', 
                                                'S-LSE-CLOSE-AP', 
                                                'S-LSE-CLOSE-VW',
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/closures']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-coins mr-2"></i>Lease Closures</a
                                                >
                                             </li>
                                              <li *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'S-LSE-ALL', 
                                                'S-LSE-INV-REP', 
                                                'S-LSE-INV-AP', 
                                                'S-LSE-INV-DISC',
                                                'S-LSE-INV-VW',
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/salesLeaseInvoices']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-file-invoice mr-2"></i>Lease Invoices</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                             'SYSTEM-ADMIN',
                                             'S-LSE-ALL', 
                                             'S-LSE-INVCREDIT-REP', 
                                             'S-LSE-INVCREDIT-AP', 
                                             'S-LSE-INVCREDIT-DISC',
                                             'S-LSE-INVCREDIT-VW',
                                             ]" 
                                             title="SalesLease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreementSales/salesLeaseInvoiceCreditNotes']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-file-invoice mr-2"></i>Lease Invoice Credit Notes</a
                                             >
                                          </li>
                                              <li *appHasRole="[
                                                'SYSTEM-ADMIN', 
                                                'S-LSE-ALL', 
                                                'S-LSE-INTI-REP',
                                                'S-LSE-INTI-VW',
                                                ]" 
                                                title="SalesLease">
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/salesLeaseIntegration']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fas fa-balance-scale mr-2"></i>Lease Integration</a
                                                >
                                             </li>
                                             <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'S-LSE-ALL', 
                                             'S-LSE-INVP-VW',
                                             ]" 
                                             title="SalesLease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreementSales/salesLeaseReceivedPayment']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-money-bill-wave mr-2"></i>Lease Invoice Payments Received</a
                                             >
                                          </li>
                                             <li *appHasRole="[
                                             'SYSTEM-ADMIN', 
                                             'S-LSE-ALL', 
                                             'S-LSE-RUN',
                                             ]" 
                                             title="SalesLease">
                                             <a [routerLink]="['/leaseManagement/leaseAgreementSales/salesLeaseInvoiceRun']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-running mr-2"></i>Lease Invoices Run</a
                                             >
                                          </li>
                                          <li
                                                *appHasRole="[
                                                   'SYSTEM-ADMIN',
                                                   'S-LSE-ALL',
                                                   'S-LSE-REPORT',
                                                ]"
                                                title="SalesLease"
                                             >
                                                <a [routerLink]="['/leaseManagement/leaseAgreementSales/leaseAgreementSalesReports']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-print mr-2"></i>Reports</a
                                                >
                                             </li>
                                          </ul>
                                       </mdb-accordion-item>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                                 <mdb-accordion-item>
                                 <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Prime Linked Interest Rate</mdb-accordion-item-head>
                                 <mdb-accordion-item-body>
                                    <mdb-accordion-item>
                                       <ul>
                                          <li
                                             *appHasRole="[
                                                'SYSTEM-ADMIN',
                                                'LSE-ALL',
                                                'S-LSE-ALL',
                                                'P-LSE-ALL',
                                                'P-LSE-CR',
                                                'P-LSE-VW',
                                                'P-LSE-INST'                                              
                                             ]"
                                             title="PrimeInterest"
                                          >
                                             <a [routerLink]="['/leaseManagement/leaseAgreement/primeLinkedInterestRate']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-percent mr-2"></i>Prime Linked Interest Rate</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item>
                                 </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </ul>
                           </mdb-accordion-item>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>
                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'SCN-PR-VW',
                           'SCN-PR-CR',
                           'SCN-PR-AP',
                           'SCN-PR-ED',
                           'SCN-PR-DL',
                           'SCN-CON-VW',
                           'SCN-CON-CR',
                           'SCN-CON-AP',
                           'SCN-CON-ED',
                           'SCN-CON-DL',
                           'SCN-VW',
                           'SCN-CR',
                           'SCN-ED',
                           'SCN-AP',
                           'SCN-DL',
                           'SCN-DP-VW',
                           'SCN-DP-DL',
                           'SCN-DP-ED',
                           'SCN-DP-AP',
                           'SCN-RP'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Scanned Assets</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'SCN-PR-VW', 'SCN-PR-CR', 'SCN-PR-AP', 'SCN-PR-ED', 'SCN-PR-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/scan/scanproject']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-project-diagram mr-2"></i> Scan Project</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'SCN-CON-VW', 'SCN-CON-CR', 'SCN-CON-AP', 'SCN-CON-ED', 'SCN-CON-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/conditionAssesment/condition']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-clipboard-check mr-2"></i> Condition Assessment Setup</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'SCN-VW', 'SCN-CR', 'SCN-ED', 'SCN-AP', 'SCN-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/scan/inventorylist']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-tasks mr-2"></i> Scanned Items</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'SCN-DP-VW', 'SCN-DP-DL', 'SCN-DP-ED', 'SCN-DP-AP']">
                                 <a routerLinkActive="active" [routerLink]="['/scan/dumpinventorylist']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-layer-group mr-2"></i> Scanned Items Dump</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'SCN-RP']">
                                 <a [routerLink]="['/scan/reportdashboard']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'RFID-Z-VW',
                           'RFID-Z-CR',
                           'RFID-Z-ED',
                           'RFID-Z-AP',
                           'RFID-Z-DL',
                           'RFID-R-VW',
                           'RFID-R-DL',
                           'RFID-R-ED',
                           'RFID-R-AP',
                           'RFID-R-CR',
                           'RFIDR-LOG-VW',
                           'RFID-M-VW',
                           'RFID-M-AP',
                           'RFID-M-ED',
                           'RFID-SEC-VW',
                           'RFID-SEC-ED',
                           'RFID-SEC-AP',
                           'RFID-ERR-VW'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> RFID Tracking</mdb-accordion-item-head>
                        <mdb-accordion-item-body
                           *appHasRole="[
                              'SYSTEM-ADMIN',
                              'RFID-Z-VW',
                              'RFID-Z-CR',
                              'RFID-Z-ED',
                              'RFID-Z-AP',
                              'RFID-Z-DL',
                              'RFID-R-VW',
                              'RFID-R-DL',
                              'RFID-R-ED',
                              'RFID-R-AP',
                              'RFID-R-CR',
                              'RFIDR-LOG-VW',
                              'RFID-M-VW',
                              'RFID-M-AP',
                              'RFID-M-ED',
                              'RFID-SEC-VW',
                              'RFID-SEC-ED',
                              'RFID-SEC-AP',
                              'RFID-ERR-VW'
                           ]"
                        >
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RFID-Z-VW', 'RFID-Z-CR', 'RFID-Z-ED', 'RFID-Z-AP', 'RFID-Z-DL']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'RFID-Z-VW', 'RFID-Z-CR', 'RFID-Z-ED', 'RFID-Z-AP', 'RFID-Z-DL']"
                                    [routerLink]="['/rfid/zone']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-tasks mr-2"></i> Zones</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RFID-R-VW', 'RFID-R-DL', 'RFID-R-ED', 'RFID-R-AP', 'RFID-R-CR']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'RFID-R-VW', 'RFID-R-DL', 'RFID-R-ED', 'RFID-R-AP', 'RFID-R-CR']"
                                    [routerLink]="['/rfid/reader']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-clone mr-2"></i> Readers</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RFIDR-LOG-VW']">
                                 <a *appHasRole="['SYSTEM-ADMIN', 'RFIDR-LOG-VW']" [routerLink]="['/rfid/readlog']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-folder mr-2"></i> Read Log</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RFID-M-VW', 'RFID-M-AP', 'RFID-M-ED']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'RFID-M-VW', 'RFID-M-AP', 'RFID-M-ED']"
                                    [routerLink]="['/rfid/movement', 'false']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-bars mr-2"></i> Movements</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RFID-SEC-VW', 'RFID-SEC-ED', 'RFID-SEC-AP']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'RFID-SEC-VW', 'RFID-SEC-ED', 'RFID-SEC-AP']"
                                    [routerLink]="['/rfid/securitymovement', 'true']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-home mr-2"></i> Security Movements</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'RFID-ERR-VW']">
                                 <a *appHasRole="['SYSTEM-ADMIN', 'RFID-ERR-VW']" [routerLink]="['/rfid/errorlog']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-exclamation-circle mr-2"></i> Error Log</a
                                 >
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'GEO-R-VW',
                           'GEO-R-CR',
                           'GEO-R-ED',
                           'GEO-R-DL',
                           'GEO-R-AP',
                           'GEO-L-VW',
                           'GEO-L-DL',
                           'GEO-L-ED',
                           'GEO-L-AP',
                           'GEO-L-CR',
                           'GEO-LT-VW',
                           'GEO-LT-CR',
                           'GEO-LT-AP',
                           'GEO-LT-ED',
                           'GEO-LT-DL',
                           'GEO-VW',
                           'GEO-CON',
                           'GIS-VIEW',
                           'GIS-EDIT'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Geographical Info</mdb-accordion-item-head>
                        <mdb-accordion-item-body
                           *appHasRole="[
                              'SYSTEM-ADMIN',
                              'GEO-R-VW',
                              'GEO-R-CR',
                              'GEO-R-ED',
                              'GEO-R-DL',
                              'GEO-R-AP',
                              'GEO-L-VW',
                              'GEO-L-DL',
                              'GEO-L-ED',
                              'GEO-L-AP',
                              'GEO-L-CR',
                              'GIS-VIEW',
                              'GIS-EDIT'
                           ]"
                        >
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'GEO-R-VW', 'GEO-R-CR', 'GEO-R-ED', 'GEO-R-DL', 'GEO-R-AP']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'GEO-R-VW', 'GEO-R-CR', 'GEO-R-ED', 'GEO-R-DL', 'GEO-R-AP', 'GIS-VIEW', 'GIS-EDIT']"
                                    [routerLink]="['/gis/region']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-map-pin mr-2"></i> Regions</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'GEO-L-VW', 'GEO-L-DL', 'GEO-L-ED', 'GEO-L-AP', 'GEO-L-CR']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'GEO-L-VW', 'GEO-L-DL', 'GEO-L-ED', 'GEO-L-AP', 'GEO-L-CR', 'GIS-VIEW', 'GIS-EDIT']"
                                    [routerLink]="['/gis/layer']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-layer-group mr-2"></i> Layers</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'GEO-L-VW', 'GEO-L-DL', 'GEO-L-ED', 'GEO-L-AP', 'GEO-L-CR']">
                                 <a
                                    *appHasRole="['SYSTEM-ADMIN', 'GEO-L-VW', 'GEO-L-DL', 'GEO-L-ED', 'GEO-L-AP', 'GEO-L-CR', 'GIS-VIEW', 'GIS-EDIT']"
                                    [routerLink]="['/gis/layertype']"
                                    class="waves-effect"
                                    mdbWavesEffect
                                    ><i class="fa fa-layer-group mr-2"></i> Layers Per Type</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'GEO-VW', 'GEO-CON']">
                                 <a *appHasRole="['SYSTEM-ADMIN', 'GEO-VW', 'GEO-CON', 'GIS-VIEW', 'GIS-EDIT']" [routerLink]="['/gis/map']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-map-marked-alt mr-2"></i> Geo Assets</a
                                 >
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        li
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'MON-VW',
                           'MON-TR',
                           'MON-LOS-VW',
                           'MON-LOS-CR',
                           'MON-LOS-AP',
                           'MON-LOS-ED',
                           'MON-LOS-DL',
                           'MON-MV-VW',
                           'MON-MV-CR',
                           'MON-MV-AP',
                           'MON-MV-ED',
                           'MON-MV-DL',
                           'MON-MVAR-VW'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Monitoring</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'MON-VW', 'MON-TR']">
                                 <a routerLinkActive="active" [routerLink]="['monitoring/dashboard']" class="waves-effect" mdbWavesEffect>
                                    <i class="fa fa-tachometer-alt mr-2"></i> Dashboard
                                 </a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'MON-LOS-VW', 'MON-LOS-CR', 'MON-LOS-AP', 'MON-LOS-ED', 'MON-LOS-DL']" class="SecondLevelMenu">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Monitoring Actions</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MON-LOS-VW', 'MON-LOS-CR', 'MON-LOS-AP', 'MON-LOS-ED', 'MON-LOS-DL']">
                                             <a routerLinkActive="active" [routerLink]="['monitoring/list/loss']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-trash-alt mr-2"></i> Lost/Stolen Assets</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'MON-MV-VW', 'MON-MV-CR', 'MON-MV-AP', 'MON-MV-ED', 'MON-MV-DL', 'MON-MVAR-VW']" class="SecondLevelMenu">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Asset Movements</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MON-MV-VW', 'MON-MV-CR', 'MON-MV-AP', 'MON-MV-ED', 'MON-MV-DL']">
                                             <a routerLinkActive="active" [routerLink]="['monitoring/assetmovement']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-project-diagram mr-2"></i> New Movements</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MON-MVAR-VW']">
                                             <a routerLinkActive="active" [routerLink]="['monitoring/assetmovementarc']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-box-open mr-2"></i> Archive</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'MTC-ALL-MANAGER',
                           'MTC-LRT-CR',
                           'MTC-LRT-AP',
                           'MTC-LRT-ED',
                           'MTC-LRT-DL',
                           'MTC-LRT-VW',
                           'MTC-LR-CR',
                           'MTC-LR-AP',
                           'MTC-LR-ED',
                           'MTC-LR-DL',
                           'MTC-LR-VW',
                           'MTC-ADJ-CR',
                           'MTC-ADJ-AP',
                           'MTC-ADJ-ED',
                           'MTC-ADJ-DL',
                           'MTC-ADJ-VW',
                           'MTC-RT-CR',
                           'MTC-RT-AP',
                           'MTC-RT-ED',
                           'MTC-RT-DL',
                           'MTC-RT-VW',
                           'MTC-AR-CR',
                           'MTC-AR-AP',
                           'MTC-AR-ED',
                           'MTC-AR-DL',
                           'MTC-AR-VW',
                           'MTC-ASR-CR',
                           'MTC-ASR-AP',
                           'MTC-ASR-ED',
                           'MTC-ASR-DL',
                           'MTC-ASR-VW',
                           'MTC-TRT-CR',
                           'MTC-TRT-AP',
                           'MTC-TRT-ED',
                           'MTC-TRT-DL',
                           'MTC-TRT-VW',
                           'MTC-TR-CR',
                           'MTC-TR-AP',
                           'MTC-TR-ED',
                           'MTC-TR-DL',
                           'MTC-TR-VW',
                           'MTC-ATR-CR',
                           'MTC-ATR-AP',
                           'MTC-ATR-ED',
                           'MTC-ATR-DL',
                           'MTC-ATR-VW',
                           'MTC-AT-CR',
                           'MTC-AT-AP',
                           'MTC-AT-ED',
                           'MTC-AT-DL',
                           'MTC-AT-VW',
                           'MTC-STR-VW',
                           'MTC-TEN-CR',
                           'MTC-TEN-AP',
                           'MTC-TEN-ED',
                           'MTC-TEN-DL',
                           'MTC-TEN-VW',
                           'MTC-TM-CR',
                           'MTC-TM-AP',
                           'MTC-TM-ED',
                           'MTC-TM-DL',
                           'MTC-TM-VW',
                           'MTC-WH-CR',
                           'MTC-WH-AP',
                           'MTC-WH-ED',
                           'MTC-WH-DL',
                           'MTC-WH-VW',
                           'MTC-ST-CR',
                           'MTC-ST-AP',
                           'MTC-ST-ED',
                           'MTC-ST-DL',
                           'MTC-ST-VW',
                           'MTC-IS-CR',
                           'MTC-IS-AP',
                           'MTC-IS-ED',
                           'MTC-IS-DL',
                           'MTC-IS-VW',
                           'MTC-RO-CR',
                           'MTC-RO-AP',
                           'MTC-RO-ED',
                           'MTC-RO-DL',
                           'MTC-RO-VW',
                           'MTC-BI-CR',
                           'MTC-BI-AP',
                           'MTC-BI-ED',
                           'MTC-BI-DL',
                           'MTC-BI-VW',
                           'MTC-PC-CR',
                           'MTC-PC-AP',
                           'MTC-PC-ED',
                           'MTC-PC-DL',
                           'MTC-PC-VW',
                           'MTC-PRT-CR',
                           'MTC-PRT-AP',
                           'MTC-PRT-ED',
                           'MTC-PRT-DL',
                           'MTC-PRT-VW',
                           'MTC-PRT-REC',
                           'MTC-REQ-CR',
                           'MTC-REQ-AP',
                           'MTC-REQ-ED',
                           'MTC-REQ-DL',
                           'MTC-REQ-VW',
                           'MTC-RET-VW',
                           'MTC-RET-COLL',
                           'MTC-RET-RET',
                           'MTC-UPS-COMP',
                           'MTC-UPS-ED',
                           'MTC-UPS-DL',
                           'MTC-UPS-VW',
                           'MTC-ATRT-ADD',
                           'MTC-ATRT-REM',
                           'MTC-ATRT-VW',
                           'MTC-WOR-CR',
                           'MTC-WOR-AP',
                           'MTC-WOR-ED',
                           'MTC-WOR-DL',
                           'MTC-WOR-VW',
                           'MTC-WOA-CR',
                           'MTC-WOA-AP',
                           'MTC-WOA-ED',
                           'MTC-WOA-DL',
                           'MTC-WOA-VW',
                           'MTC-WOT-CR',
                           'MTC-WOT-VW',
                           'MTC-WO-CR',
                           'MTC-WO-ED',
                           'MTC-WO-VW',
                           'MTC-WO-SCHED',
                           'MTC-WOS-CR',
                           'MTC-WOS-ED',
                           'MTC-WOS-VW',
                           'MTC-WOP-VW',
                           'MTC-MYWO-VW',
                           'MTC-JOBA-CR',
                           'MTC-JOBA-AP',
                           'MTC-JOBA-ED',
                           'MTC-JOBA-DL',
                           'MTC-JOBA-VW',
                           'MTC-RP'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Maintenance</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li class="SecondLevelMenu">
                                 <mdb-accordion-item
                                    *appHasRole="[
                                       'SYSTEM-ADMIN',
                                       'MTC-ALL-MANAGER',
                                       'MTC-LRT-CR',
                                       'MTC-LRT-AP',
                                       'MTC-LRT-ED',
                                       'MTC-LRT-DL',
                                       'MTC-LRT-VW',
                                       'MTC-LR-CR',
                                       'MTC-LR-AP',
                                       'MTC-LR-ED',
                                       'MTC-LR-DL',
                                       'MTC-LR-VW',
                                       'MTC-ADJ-CR',
                                       'MTC-ADJ-AP',
                                       'MTC-ADJ-ED',
                                       'MTC-ADJ-DL',
                                       'MTC-ADJ-VW',
                                       'MTC-RT-CR',
                                       'MTC-RT-AP',
                                       'MTC-RT-ED',
                                       'MTC-RT-DL',
                                       'MTC-RT-VW',
                                       'MTC-AR-CR',
                                       'MTC-AR-AP',
                                       'MTC-AR-ED',
                                       'MTC-AR-DL',
                                       'MTC-AR-VW',
                                       'MTC-ASR-CR',
                                       'MTC-ASR-AP',
                                       'MTC-ASR-ED',
                                       'MTC-ASR-DL',
                                       'MTC-ASR-VW',
                                       'MTC-TRT-CR',
                                       'MTC-TRT-AP',
                                       'MTC-TRT-ED',
                                       'MTC-TRT-DL',
                                       'MTC-TRT-VW',
                                       'MTC-TR-CR',
                                       'MTC-TR-AP',
                                       'MTC-TR-ED',
                                       'MTC-TR-DL',
                                       'MTC-TR-VW',
                                       'MTC-ATR-CR',
                                       'MTC-ATR-AP',
                                       'MTC-ATR-ED',
                                       'MTC-ATR-DL',
                                       'MTC-ATR-VW',
                                       'MTC-AT-CR',
                                       'MTC-AT-AP',
                                       'MTC-AT-ED',
                                       'MTC-AT-DL',
                                       'MTC-AT-VW',
                                       'MTC-STR-VW',
                                       'MTC-TEN-CR',
                                       'MTC-TEN-AP',
                                       'MTC-TEN-ED',
                                       'MTC-TEN-DL',
                                       'MTC-TEN-VW',
                                       'MTC-TM-CR',
                                       'MTC-TM-AP',
                                       'MTC-TM-ED',
                                       'MTC-TM-DL',
                                       'MTC-TM-VW'
                                    ]"
                                 >
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Setup</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li>
                                             <mdb-accordion-item
                                                *appHasRole="[
                                                   'SYSTEM-ADMIN',
                                                   'MTC-ALL-MANAGER',
                                                   'MTC-LRT-CR',
                                                   'MTC-LRT-AP',
                                                   'MTC-LRT-ED',
                                                   'MTC-LRT-DL',
                                                   'MTC-LRT-VW',
                                                   'MTC-LR-CR',
                                                   'MTC-LR-AP',
                                                   'MTC-LR-ED',
                                                   'MTC-LR-DL',
                                                   'MTC-LR-VW',
                                                   'MTC-ADJ-CR',
                                                   'MTC-ADJ-AP',
                                                   'MTC-ADJ-ED',
                                                   'MTC-ADJ-DL',
                                                   'MTC-ADJ-VW',
                                                   'MTC-RT-CR',
                                                   'MTC-RT-AP',
                                                   'MTC-RT-ED',
                                                   'MTC-RT-DL',
                                                   'MTC-RT-VW',
                                                   'MTC-AR-CR',
                                                   'MTC-AR-AP',
                                                   'MTC-AR-ED',
                                                   'MTC-AR-DL',
                                                   'MTC-AR-VW',
                                                   'MTC-ASR-CR',
                                                   'MTC-ASR-AP',
                                                   'MTC-ASR-ED',
                                                   'MTC-ASR-DL',
                                                   'MTC-ASR-VW',
                                                   'MTC-TRT-CR',
                                                   'MTC-TRT-AP',
                                                   'MTC-TRT-ED',
                                                   'MTC-TRT-DL',
                                                   'MTC-TRT-VW',
                                                   'MTC-TR-CR',
                                                   'MTC-TR-AP',
                                                   'MTC-TR-ED',
                                                   'MTC-TR-DL',
                                                   'MTC-TR-VW',
                                                   'MTC-ATR-CR',
                                                   'MTC-ATR-AP',
                                                   'MTC-ATR-ED',
                                                   'MTC-ATR-DL',
                                                   'MTC-ATR-VW'
                                                ]"
                                             >
                                                <mdb-accordion-item-head mdbWavesEffect
                                                   ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Resources</mdb-accordion-item-head
                                                >
                                                <mdb-accordion-item-body>
                                                   <ul>
                                                      <li>
                                                         <mdb-accordion-item
                                                            *appHasRole="[
                                                               'SYSTEM-ADMIN',
                                                               'MTC-ALL-MANAGER',
                                                               'MTC-LRT-CR',
                                                               'MTC-LRT-AP',
                                                               'MTC-LRT-ED',
                                                               'MTC-LRT-DL',
                                                               'MTC-LRT-VW',
                                                               'MTC-ADJ-CR',
                                                               'MTC-ADJ-AP',
                                                               'MTC-ADJ-ED',
                                                               'MTC-ADJ-DL',
                                                               'MTC-ADJ-VW'
                                                            ]"
                                                         >
                                                            <mdb-accordion-item-head mdbWavesEffect
                                                               ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Labour Resources</mdb-accordion-item-head
                                                            >
                                                            <mdb-accordion-item-body>
                                                               <ul>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-LRT-CR',
                                                                        'MTC-LRT-AP',
                                                                        'MTC-LRT-ED',
                                                                        'MTC-LRT-DL',
                                                                        'MTC-LRT-VW'
                                                                     ]"
                                                                  >
                                                                     <a [routerLink]="['/maintenance/labourresourcetype']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fa fa-users-cog mr-2"></i> Labour Resource Type</a
                                                                     >
                                                                  </li>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-LR-CR',
                                                                        'MTC-LR-AP',
                                                                        'MTC-LR-ED',
                                                                        'MTC-LR-DL',
                                                                        'MTC-LR-VW'
                                                                     ]"
                                                                  >
                                                                     <a [routerLink]="['/maintenance/labourresource']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fa fa-users mr-2"></i> Labour Resource</a
                                                                     >
                                                                  </li>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-ADJ-CR',
                                                                        'MTC-ADJ-AP',
                                                                        'MTC-ADJ-ED',
                                                                        'MTC-ADJ-DL',
                                                                        'MTC-ADJ-VW'
                                                                     ]"
                                                                  >
                                                                     <a [routerLink]="['/maintenance/adjustlabourresource']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fa fa-people-arrows mr-2"></i> Adjust Labour Rate</a
                                                                     >
                                                                  </li>
                                                               </ul>
                                                            </mdb-accordion-item-body>
                                                         </mdb-accordion-item>
                                                      </li>
                                                      <li>
                                                         <mdb-accordion-item
                                                            *appHasRole="[
                                                               'SYSTEM-ADMIN',
                                                               'MTC-ALL-MANAGER',
                                                               'MTC-RT-CR',
                                                               'MTC-RT-AP',
                                                               'MTC-RT-ED',
                                                               'MTC-RT-DL',
                                                               'MTC-RT-VW',
                                                               'MTC-AR-CR',
                                                               'MTC-AR-AP',
                                                               'MTC-AR-ED',
                                                               'MTC-AR-DL',
                                                               'MTC-AR-VW',
                                                               'MTC-ASR-CR',
                                                               'MTC-ASR-AP',
                                                               'MTC-ASR-ED',
                                                               'MTC-ASR-DL',
                                                               'MTC-ASR-VW'
                                                            ]"
                                                         >
                                                            <mdb-accordion-item-head mdbWavesEffect
                                                               ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Asset Resources</mdb-accordion-item-head
                                                            >
                                                            <mdb-accordion-item-body>
                                                               <ul>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-RT-CR',
                                                                        'MTC-RT-AP',
                                                                        'MTC-RT-ED',
                                                                        'MTC-RT-DL',
                                                                        'MTC-RT-VW'
                                                                     ]"
                                                                  >
                                                                     <a routerLinkActive="active" [routerLink]="['/maintenance/resourcetype']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fas fa-truck"></i>Asset Resource Type</a
                                                                     >
                                                                  </li>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-AR-CR',
                                                                        'MTC-AR-AP',
                                                                        'MTC-AR-ED',
                                                                        'MTC-AR-DL',
                                                                        'MTC-AR-VW'
                                                                     ]"
                                                                  >
                                                                     <a routerLinkActive="active" [routerLink]="['/maintenance/resource']" class="waves-effect" mdbWavesEffect>
                                                                        <i class="fas fa-truck-pickup"></i>Asset Resource
                                                                     </a>
                                                                  </li>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-ASR-CR',
                                                                        'MTC-ASR-AP',
                                                                        'MTC-ASR-ED',
                                                                        'MTC-ASR-DL',
                                                                        'MTC-ASR-VW'
                                                                     ]"
                                                                  >
                                                                     <a [routerLink]="['/maintenance/adjustresource']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fa fa-people-arrows mr-2"></i> Adjust Resource Rate</a
                                                                     >
                                                                  </li>
                                                               </ul>
                                                            </mdb-accordion-item-body>
                                                         </mdb-accordion-item>
                                                      </li>
                                                      <li>
                                                         <mdb-accordion-item
                                                            *appHasRole="[
                                                               'SYSTEM-ADMIN',
                                                               'MTC-ALL-MANAGER',
                                                               'MTC-TRT-CR',
                                                               'MTC-TRT-AP',
                                                               'MTC-TRT-ED',
                                                               'MTC-TRT-DL',
                                                               'MTC-TRT-VW',
                                                               'MTC-TR-CR',
                                                               'MTC-TR-AP',
                                                               'MTC-TR-ED',
                                                               'MTC-TR-DL',
                                                               'MTC-TR-VW',
                                                               'MTC-ATR-CR',
                                                               'MTC-ATR-AP',
                                                               'MTC-ATR-ED',
                                                               'MTC-ATR-DL',
                                                               'MTC-ATR-VW'
                                                            ]"
                                                         >
                                                            <mdb-accordion-item-head mdbWavesEffect
                                                               ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Tool Resources</mdb-accordion-item-head
                                                            >
                                                            <mdb-accordion-item-body>
                                                               <ul>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-TRT-CR',
                                                                        'MTC-TRT-AP',
                                                                        'MTC-TRT-ED',
                                                                        'MTC-TRT-DL',
                                                                        'MTC-TRT-VW'
                                                                     ]"
                                                                  >
                                                                     <a routerLinkActive="active" [routerLink]="['/maintenance/tooltype']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fas fa-wrench"></i>Tool Type</a
                                                                     >
                                                                  </li>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-TR-CR',
                                                                        'MTC-TR-AP',
                                                                        'MTC-TR-ED',
                                                                        'MTC-TR-DL',
                                                                        'MTC-TR-VW'
                                                                     ]"
                                                                  >
                                                                     <a routerLinkActive="active" [routerLink]="['/maintenance/tool']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fas fa-tools"></i>Tool</a
                                                                     >
                                                                  </li>
                                                                  <li
                                                                     *appHasRole="[
                                                                        'SYSTEM-ADMIN',
                                                                        'MTC-ALL-MANAGER',
                                                                        'MTC-ATR-CR',
                                                                        'MTC-ATR-AP',
                                                                        'MTC-ATR-ED',
                                                                        'MTC-ATR-DL',
                                                                        'MTC-ATR-VW'
                                                                     ]"
                                                                  >
                                                                     <a [routerLink]="['/maintenance/adjusttool']" class="waves-effect" mdbWavesEffect
                                                                        ><i class="fa fa-exchange-alt mr-2"></i> Adjust Tool Rate</a
                                                                     >
                                                                  </li>
                                                               </ul>
                                                            </mdb-accordion-item-body>
                                                         </mdb-accordion-item>
                                                      </li>
                                                   </ul>
                                                </mdb-accordion-item-body>
                                             </mdb-accordion-item>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-AT-CR', 'MTC-AT-AP', 'MTC-AT-ED', 'MTC-AT-DL', 'MTC-AT-VW']">
                                             <a [routerLink]="['/maintenance/activitytype']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-pencil-ruler mr-2"></i> Activity Type</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-STR-VW']">
                                             <a [routerLink]="['/maintenance/strategy']" class="waves-effect" mdbWavesEffect><i class="fa fa-directions mr-2"></i> Strategy</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TEN-CR', 'MTC-TEN-AP', 'MTC-TEN-ED', 'MTC-TEN-DL', 'MTC-TEN-VW']">
                                             <a routerLinkActive="active" [routerLink]="['/maintenance/tenant']" class="waves-effect" mdbWavesEffect
                                                ><i class="fas fa-user-tag"></i>Client</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TM-CR', 'MTC-TM-AP', 'MTC-TM-ED', 'MTC-TM-DL', 'MTC-TM-VW']">
                                             <a routerLinkActive="active" [routerLink]="['/maintenance/team']" class="waves-effect" mdbWavesEffect
                                                ><i class="fas fa-user-friends"></i>Team</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'MTC-ALL-MANAGER',
                                    'MTC-WH-CR',
                                    'MTC-WH-AP',
                                    'MTC-WH-ED',
                                    'MTC-WH-DL',
                                    'MTC-WH-VW',
                                    'MTC-ST-CR',
                                    'MTC-ST-AP',
                                    'MTC-ST-ED',
                                    'MTC-ST-DL',
                                    'MTC-ST-VW',
                                    'MTC-IS-CR',
                                    'MTC-IS-AP',
                                    'MTC-IS-ED',
                                    'MTC-IS-DL',
                                    'MTC-IS-VW',
                                    'MTC-RO-CR',
                                    'MTC-RO-AP',
                                    'MTC-RO-ED',
                                    'MTC-RO-DL',
                                    'MTC-RO-VW',
                                    'MTC-BI-CR',
                                    'MTC-BI-AP',
                                    'MTC-BI-ED',
                                    'MTC-BI-DL',
                                    'MTC-BI-VW'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Inventory Setup</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WH-CR', 'MTC-WH-AP', 'MTC-WH-ED', 'MTC-WH-DL', 'MTC-WH-VW']">
                                             <a [routerLink]="['/maintenance/warehouses']" class="waves-effect" mdbWavesEffect><i class="fa fa-home mr-2"></i> Warehouses</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ST-CR', 'MTC-ST-AP', 'MTC-ST-ED', 'MTC-ST-DL', 'MTC-ST-VW']">
                                             <a [routerLink]="['/maintenance/storerooms']" class="waves-effect" mdbWavesEffect><i class="fa fa-door-closed mr-2"></i> Storerooms</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-IS-CR', 'MTC-IS-AP', 'MTC-IS-ED', 'MTC-IS-DL', 'MTC-IS-VW']">
                                             <a [routerLink]="['/maintenance/isles']" class="waves-effect" mdbWavesEffect><i class="fa fa-grip-lines mr-2"></i> Isles</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-RO-CR', 'MTC-RO-AP', 'MTC-RO-ED', 'MTC-RO-DL', 'MTC-RO-VW']">
                                             <a [routerLink]="['/maintenance/rows']" class="waves-effect" mdbWavesEffect><i class="fa fa-sitemap mr-2"></i> Rows</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-BI-CR', 'MTC-BI-AP', 'MTC-BI-ED', 'MTC-BI-DL', 'MTC-BI-VW']">
                                             <a [routerLink]="['/maintenance/bins']" class="waves-effect" mdbWavesEffect><i class="fa fa-dumpster mr-2"></i> Bins</a>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'MTC-ALL-MANAGER',
                                    'MTC-PC-CR',
                                    'MTC-PC-AP',
                                    'MTC-PC-ED',
                                    'MTC-PC-DL',
                                    'MTC-PC-VW',
                                    'MTC-PRT-CR',
                                    'MTC-PRT-AP',
                                    'MTC-PRT-ED',
                                    'MTC-PRT-DL',
                                    'MTC-PRT-VW',
                                    'MTC-PRT-REC',
                                    'MTC-REQ-CR',
                                    'MTC-REQ-AP',
                                    'MTC-REQ-ED',
                                    'MTC-REQ-DL',
                                    'MTC-REQ-VW',
                                    'MTC-RET-VW',
                                    'MTC-RET-COLL',
                                    'MTC-RET-RET'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Parts</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-PC-CR', 'MTC-PC-AP', 'MTC-PC-ED', 'MTC-PC-DL', 'MTC-PC-VW']">
                                             <a [routerLink]="['/maintenance/partcategory']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-sitemap mr-2"></i> Part Category</a
                                             >
                                          </li>
                                          <li
                                             *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-PRT-CR', 'MTC-PRT-AP', 'MTC-PRT-ED', 'MTC-PRT-DL', 'MTC-PRT-VW', 'MTC-PRT-REC']"
                                          >
                                             <a [routerLink]="['/maintenance/part']" class="waves-effect" mdbWavesEffect><i class="fa fa-wrench mr-2"></i> Manage Parts</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-REQ-CR', 'MTC-REQ-AP', 'MTC-REQ-ED', 'MTC-REQ-DL', 'MTC-REQ-VW']">
                                             <a [routerLink]="['/maintenance/stockrequisition']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-shopping-basket mr-2"></i> Stock Requisition</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-RET-VW', 'MTC-RET-COLL', 'MTC-RET-RET']">
                                             <a [routerLink]="['/maintenance/workorder/collection']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-exchange-alt mr-2"></i> Collect/Return Parts</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'MTC-ALL-MANAGER',
                                    'MTC-UPS-COMP',
                                    'MTC-UPS-ED',
                                    'MTC-UPS-DL',
                                    'MTC-UPS-VW',
                                    'MTC-ATRT-ADD',
                                    'MTC-ATRT-REM',
                                    'MTC-ATRT-VW'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Asset Usage Monitoring</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-UPS-COMP', 'MTC-UPS-ED', 'MTC-UPS-DL', 'MTC-UPS-VW']">
                                             <a [routerLink]="['/maintenance/usage']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-tachometer-alt mr-2"></i> Assets Pending Setup</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ATRT-ADD', 'MTC-ATRT-REM', 'MTC-ATRT-VW']">
                                             <a [routerLink]="['/maintenance/usage/active']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-chart-line mr-2"></i> Assets Tracking Active</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'MTC-ALL-MANAGER',
                                    'MTC-WOR-CR',
                                    'MTC-WOR-AP',
                                    'MTC-WOR-ED',
                                    'MTC-WOR-DL',
                                    'MTC-WOR-VW',
                                    'MTC-WOA-CR',
                                    'MTC-WOA-AP',
                                    'MTC-WOA-ED',
                                    'MTC-WOA-DL',
                                    'MTC-WOA-VW',
                                    'MTC-WOT-CR',
                                    'MTC-WOT-VW',
                                    'MTC-WO-CR',
                                    'MTC-WO-ED',
                                    'MTC-WO-VW',
                                    'MTC-WO-SCHED',
                                    'MTC-WOS-CR',
                                    'MTC-WOS-ED',
                                    'MTC-WOS-VW',
                                    'MTC-WOP-VW',
                                    'MTC-MYWO-VW',
                                    'MTC-JOBA-CR',
                                    'MTC-JOBA-AP',
                                    'MTC-JOBA-ED',
                                    'MTC-JOBA-DL',
                                    'MTC-JOBA-VW'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Work Order</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WOR-CR', 'MTC-WOR-AP', 'MTC-WOR-ED', 'MTC-WOR-DL', 'MTC-WOR-VW']">
                                             <a [routerLink]="['/maintenance/requisition']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-shopping-basket mr-2"></i> Requests</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WOA-CR', 'MTC-WOA-AP', 'MTC-WOA-ED', 'MTC-WOA-DL', 'MTC-WOA-VW']">
                                             <a [routerLink]="['/maintenance/activity']" class="waves-effect" mdbWavesEffect><i class="fa fa-wrench mr-2"></i>Activities</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WOT-CR', 'MTC-WOT-VW']">
                                             <a [routerLink]="['/maintenance/group']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-object-group mr-2"></i>Triggered Assets</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WO-CR', 'MTC-WO-ED', 'MTC-WO-VW', 'MTC-WO-SCHED']">
                                             <a [routerLink]="['/maintenance/workorder']" class="waves-effect" mdbWavesEffect><i class="fa fa-briefcase mr-2"></i>Work Orders</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WOS-CR', 'MTC-WOS-ED', 'MTC-WOS-VW']">
                                             <a [routerLink]="['/maintenance/schedule']" class="waves-effect" mdbWavesEffect><i class="fa fa-calendar-alt mr-2"></i> Schedule</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WOP-VW']">
                                             <a [routerLink]="['/maintenance/pickworkorder/null']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-hand-pointer mr-2"></i> Pick Work Order</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-MYWO-VW']">
                                             <a [routerLink]="['/maintenance/workorder/owner']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-user-edit mr-2"></i> My Work Orders</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-JOBA-CR', 'MTC-JOBA-AP', 'MTC-JOBA-ED', 'MTC-JOBA-DL', 'MTC-JOBA-VW']">
                                             <a [routerLink]="['/maintenance/jobcard/jobcard-assessment']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-clipboard-check mr-2"></i> Job Card Assessment</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER']">
                                 <a [routerLink]="['/maintenance/settings']" class="waves-effect" mdbWavesEffect><i class="fa fa-cog mr-2"></i> Settings</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-RP']">
                                 <a [routerLink]="['/maintenance/reportdashboard']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'INT-ST1-VW',
                           'INT-ST1-ED',
                           'INT-ST2-VW',
                           'INT-ST2-ED',
                           'INT-ST3-VW',
                           'INT-ST3-ED',
                           'INT-ST4-VW',
                           'INT-ST4-CR',
                           'INT-ST4-ED',
                           'INT-EXT-VW',
                           'INT-ARC-VW',
                           'INT-ACC-VW',
                           'INT-ASS-VW',
                           'INT-SUP-VW',
                           'INT-ERR-VW',
                           'INT-SCNA-VW',
                           'INT-SERR-VW'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> ERP Integration</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'INT-SCNA-VW', 'INT-SERR-VW']" class="SecondLevelMenu">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Scan Integration</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-SCNA-VW']">
                                             <a [routerLink]="['/scan/scanintegrated']" class="waves-effect" mdbWavesEffect
                                                ><i class="k-icon k-i-file-ascx mr-2"></i> Approved Assets</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-SERR-VW']">
                                             <a [routerLink]="['/integration/errors']" class="waves-effect" mdbWavesEffect><i class="fa fa-exclamation-circle mr-2"></i> Errors</a>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'INT-ST1-VW',
                                    'INT-ST1-ED',
                                    'INT-ST2-VW',
                                    'INT-ST2-ED',
                                    'INT-ST3-VW',
                                    'INT-ST3-ED',
                                    'INT-ST4-VW',
                                    'INT-ST4-CR',
                                    'INT-ST4-ED',
                                    'INT-EXT-VW',
                                    'INT-ARC-VW'
                                 ]"
                                 class="SecondLevelMenu"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>ERP Imports</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <ng-template [ngIf]="integrateWith" [ngIfElse]="advancedExternalImport">
                                             <li
                                                li
                                                *appHasRole="[
                                                   'SYSTEM-ADMIN',
                                                   'INT-ST1-VW',
                                                   'INT-ST1-ED',
                                                   'INT-ST2-VW',
                                                   'INT-ST2-ED',
                                                   'INT-ST3-VW',
                                                   'INT-ST3-ED',
                                                   'INT-ST4-VW',
                                                   'INT-ST4-CR',
                                                   'INT-ST4-ED'
                                                ]"
                                             >
                                                <a [routerLink]="['integration/importsNormal']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-flag mr-2"></i> Asset Invoice Imports</a
                                                >
                                             </li>
                                             <li li *appHasRole="['SYSTEM-ADMIN', 'INT-ARC-VW']">
                                                <a [routerLink]="['integration/importsNormalArchive']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-archive mr-2"></i> Archived Invoices</a
                                                >
                                             </li>
                                             <li li *appHasRole="['SYSTEM-ADMIN', 'INT-ARC-VW']">
                                                <a [routerLink]="['integration/importsNormalDiscard']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-trash mr-2"></i> Discarded Invoices</a
                                                >
                                             </li>
                                          </ng-template>
                                          <ng-template #advancedExternalImport>
                                             <li>
                                                <a [routerLink]="['integration/imports']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-flag mr-2"></i> Asset Invoice Imports</a
                                                >
                                             </li>
                                             <li>
                                                <a routerLinkActive="active" [routerLink]="['/integration/archived-invoices']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-archive mr-2"></i> Archived Invoices</a
                                                >
                                             </li>
                                             <li>
                                                <a routerLinkActive="active" [routerLink]="['/integration/importsNormalDiscard']" class="waves-effect" mdbWavesEffect
                                                   ><i class="fa fa-trash mr-2"></i> Discarded Invoices</a
                                                >
                                             </li>
                                          </ng-template>

                                          <li>
                                             <a routerLinkActive="active" [routerLink]="['/integration/asset-journal-imports']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-adjust mr-2"></i> Asset Journal Imports</a
                                             >
                                          </li>
                                          <li>
                                             <a routerLinkActive="active" [routerLink]="['/integration/asset-sales-imports']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-money-bill mr-2"></i> Asset Sales Imports</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'INT-ACC-VW', 'INT-ASS-VW', 'INT-SUP-VW', 'INT-ERR-VW']" class="ThridLevelMenu">
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Integration Audit</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-ACC-VW']">
                                             <a [routerLink]="['/integration/accounts']" class="waves-effect" mdbWavesEffect><i class="k-icon k-i-file-ascx mr-2"></i> Accounts</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-ASS-VW']">
                                             <a [routerLink]="['/integration/assets']" class="waves-effect" mdbWavesEffect><i class="k-icon k-i-file-ascx mr-2"></i> Assets</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-SUP-VW']">
                                             <a [routerLink]="['/integration/suppliers']" class="waves-effect" mdbWavesEffect
                                                ><i class="k-icon k-i-file-ascx mr-2"></i> Suppliers</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-SUP-VW']">
                                             <a [routerLink]="['/integration/customers']" class="waves-effect" mdbWavesEffect
                                                ><i class="k-icon k-i-file-ascx mr-2"></i> Customers</a
                                             >
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'INT-ERR-VW']">
                                             <a [routerLink]="['/integration/errors']" class="waves-effect" mdbWavesEffect><i class="fa fa-exclamation-circle mr-2"></i> Errors</a>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'INS-VW',
                           'INS-CR',
                           'INS-ED',
                           'INS-AP',
                           'INS-DL',
                           'INS-POL-VW',
                           'INS-POL-CR',
                           'INS-POL-ED',
                           'INS-POL-AP',
                           'INS-POL-DL',
                           'INS-CON-VW',
                           'INS-CON-CR',
                           'INS-CON-AP',
                           'INS-CON-ED',
                           'INS-CON-DL',
                           'INS-GR-VW',
                           'INS-GR-CR',
                           'INS-GR-ED',
                           'INS-GR-AP',
                           'INS-GR-DL',
                           'INS-LK-VW',
                           'INS-LK-CR',
                           'INS-LK-ED',
                           'INS-LK-AP',
                           'INS-LK-DL',
                           'INS_REG-VW',
                           'INS-PEN-VW',
                           'INS-PEN-INS',
                           'INS-PEN-AP',
                           'INS-CLM-VW',
                           'INS-CLM-SUB',
                           'INS-CLM-ED',
                           'INS-RP'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Insurance</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li
                                 class="SecondLevelMenu"
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'INS-VW',
                                    'INS-CR',
                                    'INS-ED',
                                    'INS-AP',
                                    'INS-DL',
                                    'INS-POL-VW',
                                    'INS-POL-CR',
                                    'INS-POL-ED',
                                    'INS-POL-AP',
                                    'INS-POL-DL',
                                    'INS-CON-VW',
                                    'INS-CON-CR',
                                    'INS-CON-AP',
                                    'INS-CON-ED',
                                    'INS-CON-DL',
                                    'INS-GR-VW',
                                    'INS-GR-CR',
                                    'INS-GR-ED',
                                    'INS-GR-AP',
                                    'INS-GR-DL',
                                    'INS-LK-VW',
                                    'INS-LK-CR',
                                    'INS-LK-ED',
                                    'INS-LK-AP',
                                    'INS-LK-DL'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Configure</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li title="Create / Edit an Insurer" *appHasRole="['SYSTEM-ADMIN', 'INS-VW', 'INS-CR', 'INS-ED', 'INS-AP', 'INS-DL']">
                                             <a [routerLink]="['/insurance/insurer']" class="waves-effect" mdbWavesEffect><i class="fa fa-user mr-2"></i> Insurers</a>
                                          </li>
                                          <li
                                             title="Create / Edit a Policy - this needs to be linked to an Insurer"
                                             *appHasRole="['SYSTEM-ADMIN', 'INS-POL-VW', 'INS-POL-CR', 'INS-POL-ED', 'INS-POL-AP', 'INS-POL-DL']"
                                          >
                                             <a [routerLink]="['/insurance/policy']" class="waves-effect" mdbWavesEffect><i class="k-icon k-i-file-ascx mr-2"></i> Policies</a>
                                          </li>
                                          <li
                                             title="Create / Edit a Contact - this needs to be linked to an Insurer"
                                             *appHasRole="['SYSTEM-ADMIN', 'INS-CON-VW', 'INS-CON-CR', 'INS-CON-AP', 'INS-CON-ED', 'INS-CON-DL']"
                                          >
                                             <a [routerLink]="['/insurance/ins-contact']" class="waves-effect" mdbWavesEffect><i class="fa fa-users mr-2"></i> Contacts</a>
                                          </li>
                                          <li
                                             title="Create / Edit a Group - this needs to be linked to a Policy"
                                             *appHasRole="['SYSTEM-ADMIN', 'INS-GR-VW', 'INS-GR-CR', 'INS-GR-ED', 'INS-GR-AP', 'INS-GR-DL']"
                                          >
                                             <a [routerLink]="['/insurance/ins-group']" class="waves-effect" mdbWavesEffect><i class="fa fa-users-cog mr-2"></i> Groups</a>
                                          </li>
                                          <li
                                             title="Create / Edit links between Groups and Assets - this requires a Group"
                                             *appHasRole="['SYSTEM-ADMIN', 'INS-LK-VW', 'INS-LK-CR', 'INS-LK-ED', 'INS-LK-AP', 'INS-LK-DL']"
                                          >
                                             <a [routerLink]="['/insurance/ins-assets']" class="waves-effect" mdbWavesEffect
                                                ><i class="k-icon k-i-toggle-full-screen-mode mr-2"></i> Link Assets to Groups</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>
                              <li
                                 class="SecondLevelMenu"
                                 *appHasRole="['SYSTEM-ADMIN', 'INS_REG-VW', 'INS-PEN-VW', 'INS-PEN-INS', 'INS-PEN-AP', 'INS-CLM-VW', 'INS-CLM-SUB', 'INS-CLM-ED']"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect
                                       ><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i> Processing</mdb-accordion-item-head
                                    >
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li title="Export all Assets from the Insurance Register for a chosen period" *appHasRole="['SYSTEM-ADMIN', 'INS_REG-VW']">
                                             <a *appHasRole="['SYSTEM-ADMIN']" [routerLink]="['/insurance/insurance-register']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-chart-line mr-2"></i> Insurance Register</a
                                             >
                                          </li>
                                          <li
                                             title="View a list of Assets that are on the system, but not insured"
                                             *appHasRole="['SYSTEM-ADMIN', 'INS-PEN-VW', 'INS-PEN-INS', 'INS-PEN-AP']"
                                          >
                                             <a *appHasRole="['SYSTEM-ADMIN']" [routerLink]="['/insurance/pending-list']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-balance-scale mr-2"></i> Pending List</a
                                             >
                                          </li>
                                          <li
                                             title="Log a new Insurance Claim or process existing Claims"
                                             *appHasRole="['SYSTEM-ADMIN', 'INS-CLM-VW', 'INS-CLM-SUB', 'INS-CLM-ED']"
                                          >
                                             <a *appHasRole="['SYSTEM-ADMIN']" [routerLink]="['/insurance/claim']" class="waves-effect" mdbWavesEffect
                                                ><i class="fa fa-check mr-2"></i> Claim Processing</a
                                             >
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'INS-RP']" title="View all available Insurance Reports">
                                 <a [routerLink]="['/insurance/ins-report']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="[
                           'SYSTEM-ADMIN',
                           'WAR-TP-VW',
                           'WAR-TP-CR',
                           'WAR-TP-ED',
                           'WAR-TP-AP',
                           'WAR-TP-DL',
                           'WAR-PROV-VW',
                           'WAR-PROV-CR',
                           'WAR-PROV-ED',
                           'WAR-PROV-AP',
                           'WAR-PROV-DL',
                           'WAR-CON-VW',
                           'WAR-CON-CR',
                           'WAR-CON-ED',
                           'WAR-CON-AP',
                           'WAR-CON-DL',
                           'WAR-VW',
                           'WAR-CR',
                           'WAR-ED',
                           'WAR-AP',
                           'WAR-DL',
                           'WAR-RP'
                        ]"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Warranty Management</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li
                                 *appHasRole="[
                                    'SYSTEM-ADMIN',
                                    'WAR-TP-VW',
                                    'WAR-TP-CR',
                                    'WAR-TP-ED',
                                    'WAR-TP-AP',
                                    'WAR-TP-DL',
                                    'WAR-PROV-VW',
                                    'WAR-PROV-CR',
                                    'WAR-PROV-ED',
                                    'WAR-PROV-AP',
                                    'WAR-PROV-DL',
                                    'WAR-CON-VW',
                                    'WAR-CON-CR',
                                    'WAR-CON-ED',
                                    'WAR-CON-AP',
                                    'WAR-CON-DL'
                                 ]"
                              >
                                 <mdb-accordion-item>
                                    <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-nothing"></i><i class="fa fa-folder yellow-text"></i>Setup</mdb-accordion-item-head>
                                    <mdb-accordion-item-body>
                                       <ul>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'WAR-TP-VW', 'WAR-TP-CR', 'WAR-TP-ED', 'WAR-TP-AP', 'WAR-TP-DL']">
                                             <a [routerLink]="['/warranty/types']" class="waves-effect" mdbWavesEffect><i class="fa fa-paperclip mr-2"></i> Types</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'WAR-PROV-VW', 'WAR-PROV-CR', 'WAR-PROV-ED', 'WAR-PROV-AP', 'WAR-PROV-DL']">
                                             <a [routerLink]="['/warranty/providers']" class="waves-effect" mdbWavesEffect><i class="fa fa-truck mr-2"></i> Providers</a>
                                          </li>
                                          <li *appHasRole="['SYSTEM-ADMIN', 'WAR-CON-VW', 'WAR-CON-CR', 'WAR-CON-ED', 'WAR-CON-AP', 'WAR-CON-DL']">
                                             <a [routerLink]="['/warranty/contractors']" class="waves-effect" mdbWavesEffect><i class="fa fa-hard-hat mr-2"></i> Contractors</a>
                                          </li>
                                       </ul>
                                    </mdb-accordion-item-body>
                                 </mdb-accordion-item>
                              </li>

                              <li *appHasRole="['SYSTEM-ADMIN', 'WAR-VW', 'WAR-CR', 'WAR-ED', 'WAR-AP', 'WAR-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/warranty/all']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-list-alt mr-2"></i>All Warranties</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WAR-RP']">
                                 <a [routerLink]="['/warranty/reports']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>


                     <mdb-accordion-item li *appHasRole="['SYSTEM-ADMIN', 'LICM-VW', 'LICM-CR', 'LICM-ED', 'LICM-DL']">
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i>License Management</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'LICM-VW', 'LICM-CR', 'LICM-ED', 'LICM-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/licenseManagement/all']" class="waves-effect" mdbWavesEffect><i class="fa fa-certificate mr-2"></i> Licenses</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'LICM-VW', 'LICM-CR', 'LICM-ED', 'LICM-DL']">
                                 <a routerLinkActive="active" [routerLink]="['/licenseManagement/renewalHistory']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-history mr-2"></i> Renewal History</a
                                 >
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>



                     <!-- Booking Manager -->
                     <!------------------>
                     <mdb-accordion-item *appHasRole="['SYSTEM-ADMIN', 'BM-ALL', 'BM-CL-ED', 'BM-CL-CR', 'BM-CL-VW', 'BM-VW', 'BM-CR', 'BM-ED', 'BM-RP', 'BM-CL-VW']">
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Booking Management</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'BM-ALL', 'BM-VW', 'BM-CR', 'BM-ED']" title="Booking">
                                 <a [routerLink]="['/bookingManagement/bookings']" class="waves-effect" mdbWavesEffect><i class="fa fa-exchange-alt mr-2"></i> Booking</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'BM-CL-CR', 'BM-CL-VW', 'BM-CL-ED', 'BM-ALL']" title="Clients">
                                 <a [routerLink]="['/bookingManagement/client']" class="waves-effect" mdbWavesEffect><i class="fa fa-user mr-2"></i> Clients</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'BM-ALL', 'BM-VW', 'BM-VW']" title="Asset">
                                 <a [routerLink]="['/bookingManagement/bmm-asset']" class="waves-effect" mdbWavesEffect><i class="fa fa-project-diagram mr-2"></i> Asset</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'BM-ALL', 'BM-VW', 'BM-ED']" title="Monitoring">
                                 <a [routerLink]="['/bookingManagement/monitorBookings']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-tachometer-alt mr-2"></i> Monitoring</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'BM-RP', 'BM-ALL']" title="Reports">
                                 <a [routerLink]="['/bookingManagement/reportsBookings']" class="waves-effect" mdbWavesEffect><i class="fa fa-print mr-2"></i> Reports</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>

                     <mdb-accordion-item
                        *appHasRole="['SYSTEM-ADMIN', 'WF-SET-CR', 'WF-SET-ED', 'WF-SET-VW', 'WF-VW', 'WF-APP-AP', 'WF-APP-REJ', 'WF-APP-REM', 'WF-APP-V', 'WF-REJ-VW', 'WF-ALL']"
                     >
                        <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Workflow</mdb-accordion-item-head>
                        <mdb-accordion-item-body>
                           <ul>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WF-SET-CR', 'WF-SET-ED', 'WF-SET-VW']">
                                 <a *appHasRole="['SYSTEM-ADMIN']" [routerLink]="['/workflow/setup']" class="waves-effect" mdbWavesEffect><i class="fa fa-cog mr-2"></i> Setup</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WF-VW']">
                                 <a *appHasRole="['SYSTEM-ADMIN']" [routerLink]="['/workflow/all']" class="waves-effect" mdbWavesEffect
                                    ><i class="fa fa-list-alt mr-2"></i> All Workflows</a
                                 >
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WF-APP-V']">
                                 <a [routerLink]="['/workflow/open']" class="waves-effect" mdbWavesEffect><i class="fa fa-check mr-2"></i> Approvals</a>
                              </li>
                              <li *appHasRole="['SYSTEM-ADMIN', 'WF-REJ-VW']">
                                 <a [routerLink]="['/workflow/rejected']" class="waves-effect" mdbWavesEffect><i class="fa fa-thumbs-down mr-2"></i> Rejections to Review</a>
                              </li>
                           </ul>
                        </mdb-accordion-item-body>
                     </mdb-accordion-item>
                     <!-- <mdb-accordion-item>
      <mdb-accordion-item-head mdbWavesEffect><i class="fa fa-folder yellow-text"></i> Help</mdb-accordion-item-head>
      <mdb-accordion-item-body>
         <ul>
            <li>
               <a [routerLink]="['/help/main']" class="waves-effect" mdbWavesEffect><i class="fa fa-cog mr-2"></i> Main</a>
            </li>

         </ul>
      </mdb-accordion-item-body>
   </mdb-accordion-item> -->
                  </mdb-accordion>
               </ul>
            </li>
            <!--/. Side navigation links -->
         </links>
         <div class="sidenav-bg mask-strong"></div>
      </mdb-side-nav>

      <!--/. Sidebar navigation -->
      <!-- Navbar -->

      <mdb-navbar SideClass="navbar fixed-top navbar-toggleable-md navbar-expand-lg scrolling-navbar double-nav" [containerInside]="false">
         <navlinks class="navbar-container">
            <div class="float-left">
               <div class="d-flex" kendoTooltip tooltipClass="tooltip-ams">
                  <div>
                     <a (click)="sidenav.show()" class="button-collapse mb-2"><i class="fa fa-bars"></i></a>
                  </div>

                  <a title="Change Settings" class="ml-3 mt-2" *appHasRole="['SYSTEM-ADMIN']" style="z-index: 10000" [routerLink]="['/admin/setting']">
                     <div class="h3"><i class="fa fa-cog"></i></div>
                  </a>
                  <a title="Home" class="ml-3 mt-2" style="z-index: 10000" [routerLink]="['/']">
                     <div class="h3"><i class="fa fa-home"></i></div>
                  </a>
               </div>
            </div>
         </navlinks>

         <mdb-navbar-brand>
            <!-- Breadcrumb-->
            <div class="breadcrumbs breadcrumb-dn mr-auto">
               <p></p>
            </div>
            <!--/. Breadcrumb-->
         </mdb-navbar-brand>

         <navlinks>
            <ul class="nav navbar-nav nav-flex-icons ml-auto ie-double-nav">
               <!--   <li class="nav-item">
               <a class="nav-link waves-light" mdbWavesEffect><i class="fa fa-envelope"></i> <span class="clearfix d-none d-sm-inline-block">Contact</span></a>
           </li>
           <li class="nav-item">
               <a class="nav-link waves-light" mdbWavesEffect><i class="fa fa-comments-o"></i> <span class="clearfix d-none d-sm-inline-block">Support</span></a>
           </li>
           <li class="nav-item">
               <a class="nav-link waves-light" mdbWavesEffect><i class="fa fa-user"></i> <span class="clearfix d-none d-sm-inline-block">Account</span></a>
           </li> -->

               <img
                  style="height: 40px; width: 40px"
                  src="{{ this.user.url ? baseUrl + profilePic : '../assets/img/user.png' }}"
                  class="img-fluid rounded-circle z-depth-2"
                  alt="Profile"
               />

               <li class="nav-item dropdown btn-group" dropdown>
                  <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
                     {{ user?.name }}
                  </a>
                  <div class="dropdown-menu dropdown-primary dropdown-menu-right" role="menu">
                     <a class="dropdown-item" [routerLink]="['/admin/profile']"><i class="fa fa-user-circle"></i> Profile</a>
                     <a class="dropdown-item" (click)="logout()"><i class="fa fa-power-off"></i> Logout</a>
                  </div>
               </li>
            </ul>
         </navlinks>
      </mdb-navbar>
   </div>

   <!--/. Navbar -->
</header>
<!--/.Double navigation-->
